// import React, { useState, useEffect, useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';

// const EnterpriseDashboard = () => {
//   const [isLoading, setIsLoading] = useState(true);
//   const [activeTab, setActiveTab] = useState('dashboard');
//   const [isDarkMode, setIsDarkMode] = useState(false); 
//   const [isSmsPopupOpen, setIsSmsPopupOpen] = useState(false);
//   const navigate = useNavigate();

//   // Colors based on your request
//   const THEME = {
//     primary: '#0C4550',   // Deep Teal
//     accent: '#F46653',    // Coral Red
//     bgLight: '#F0EFEB',   // Requested light BG
//     bgDark: '#051F24',    // Dark mode variant
//     cardLight: '#FFFFFF',
//     cardDark: '#082f36',
//     textLight: '#1e293b',
//     textDark: '#e2e8f0',
//   };

//   // --- STATIC MOCK DATA ---
//   const [dashboardStats, setDashboardStats] = useState({
//     availableCredits: 1250.50,
//     pending: 45,
//     totalSent: 12840,
//     delivered: 12100,
//     failed: 695
//   });

//   const [smsFormData, setSmsFormData] = useState({ senderId: '', templateId: '', template: '' });

//   // Simulation of initial loading without API calls
//   useEffect(() => {
//     const timer = setTimeout(() => setIsLoading(false), 800);
//     return () => clearTimeout(timer);
//   }, []);

//   // --- CALCULATIONS ---
//   const successRate = dashboardStats.totalSent > 0
//     ? ((dashboardStats.delivered / dashboardStats.totalSent) * 100).toFixed(1)
//     : 0;

//   const pieData = [
//     { label: 'Delivered', value: dashboardStats.delivered, color: '#10B981' }, 
//     { label: 'Queued', value: dashboardStats.pending, color: '#F59E0B' },       
//     { label: 'Rejected', value: dashboardStats.failed, color: THEME.accent }, 
//   ];

//   const totalForPie = pieData.reduce((sum, d) => sum + d.value, 0) || 1;
//   const radius = 30;
//   const circumference = 2 * Math.PI * radius;
//   let cumulative = 0;
//   const pieSegments = pieData.map((item) => {
//     const ratio = item.value / totalForPie;
//     const segment = { ...item, ratio, offset: cumulative };
//     cumulative += ratio;
//     return segment;
//   });

//   const chartData = useMemo(() => [40, 65, 50, 85, 70, 100, 90, 120, 110, 95, 130, 80], []);
//   const maxChartVal = Math.max(...chartData) * 1.2;

//   const handleSmsSubmit = (e) => {
//     e.preventDefault();
//     console.log("Mock SMS Submit:", smsFormData);
//     setIsSmsPopupOpen(false);
//   };

//   // --- SUB-COMPONENTS ---
//   const ThemeToggle = () => (
//     <button
//       onClick={() => setIsDarkMode(!isDarkMode)}
//       className={`p-2 rounded-full transition-all duration-300 ${isDarkMode ? 'bg-slate-700 text-yellow-400' : 'bg-slate-200 text-slate-600'}`}
//       title="Toggle Night Mode"
//     >
//       {isDarkMode ? (
//         <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" /></svg>
//       ) : (
//         <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" /></svg>
//       )}
//     </button>
//   );

//   const CompactStatCard = ({ label, value, subLabel, iconPath, accentColor }) => (
//     <div className={`
//       relative overflow-hidden rounded-2xl p-5 border transition-all duration-300 group
//       ${isDarkMode ? 'bg-[#082f36] border-[#0C4550]' : 'bg-white border-slate-100'}
//       hover:shadow-lg
//     `}>
//       <div className="flex justify-between items-start z-10 relative">
//         <div>
//           <p className={`text-[11px] font-bold uppercase tracking-wider mb-2 font-manrope ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{label}</p>
//           <h3 className={`text-2xl font-extrabold font-manrope tracking-tight ${isDarkMode ? 'text-white' : 'text-[#0C4550]'}`}>{value}</h3>
//           {subLabel && (
//             <div className={`inline-flex items-center gap-1 mt-2 px-2 py-0.5 rounded text-[10px] font-bold ${isDarkMode ? 'bg-slate-800 text-slate-300' : 'bg-slate-50 text-slate-500'}`}>
//               {subLabel}
//             </div>
//           )}
//         </div>
//         <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-white shadow-md group-hover:scale-110 transition-transform duration-300`} style={{ backgroundColor: accentColor }}>
//           <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
//             {iconPath}
//           </svg>
//         </div>
//       </div>
//       <div className="absolute -bottom-4 -right-4 w-20 h-20 bg-current opacity-5 rounded-full blur-2xl pointer-events-none" style={{ color: accentColor }}></div>
//     </div>
//   );

//   if (isLoading)
//     return (
//       <div className="min-h-screen w-full flex items-center justify-center bg-[#F0EFEB]">
//         <div className="animate-spin rounded-full h-10 w-10 border-b-2 border-[#0C4550]"></div>
//       </div>
//     );

//   return (
//     <div className={`w-full min-h-screen font-sans transition-colors duration-500 pb-10 ${isDarkMode ? 'bg-[#051F24]' : 'bg-[#F0EFEB]'}`}>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800&display=swap');
//         .font-manrope { font-family: 'Manrope', sans-serif; }
//       `}</style>

//       {/* --- NAV BAR --- */}
//       <nav className={`sticky top-0 z-30 backdrop-blur-md border-b px-4 md:px-6 py-4 transition-colors duration-300 
//         ${isDarkMode ? 'bg-[#082f36]/80 border-slate-700' : 'bg-white/80 border-slate-200'}`}>
//         <div className="mx-auto flex justify-between items-center">
//           <div className="flex items-center gap-2 md:gap-3">
//             <div className="w-9 h-9 bg-gradient-to-br from-[#0C4550] to-[#1a6b7a] rounded-xl flex items-center justify-center text-white font-extrabold text-sm shadow-md">EF</div>
//             <span className={`font-extrabold text-xl font-manrope hidden sm:block ${isDarkMode ? 'text-white' : 'text-[#0C4550]'}`}>Eurofox</span>
//           </div>
          
//           <div className="flex items-center gap-2 md:gap-4">
//             <div className="flex gap-1 p-1 rounded-full">
//                {['Dashboard', 'Reports', 'Settings'].map(tab => (
//                  <button 
//                    key={tab}
//                    onClick={() => tab === 'Dashboard' ? setActiveTab('dashboard') : null}
//                    className={`px-3 md:px-4 py-1.5 text-[10px] sm:text-xs font-medium rounded-full transition-all duration-300 
//                      ${activeTab === tab.toLowerCase() 
//                        ? `bg-[#0C4550] text-white shadow-md` 
//                        : isDarkMode ? ' text-slate-300 hover:bg-slate-800' : 'text-gray-700 hover:bg-slate-100'}`
//                    }
//                  >
//                    {tab}
//                  </button>
//                ))}
//             </div>
//             <div className={`h-6 w-px ${isDarkMode ? 'bg-slate-700' : 'bg-slate-300'}`}></div>
//             <ThemeToggle />
//           </div>
//         </div>
//       </nav>

//       {/* --- MAIN CONTENT --- */}
//       <main className="max-w-7xl mx-auto p-6 space-y-6">
//         <div className="flex flex-col md:flex-row justify-between items-end gap-4">
//             <div>
//                 <h1 className={`text-3xl font-extrabold font-manrope ${isDarkMode ? 'text-white' : 'text-[#0C4550]'}`}>Enterprise Dashboard</h1>
//                 <p className={`text-sm font-medium mt-1 ${isDarkMode ? 'text-slate-400' : 'text-gray-700'}`}>Welcome back, here's what's happening today.</p>
//             </div>
//             <button 
//                 onClick={() => setIsSmsPopupOpen(true)}
//                 className="bg-[#0C4550] text-white text-medium font-medium py-3 px-6 rounded-xl transition-all duration-300 ease-in-out flex items-center gap-2 hover:-translate-y-1 hover:shadow-lg"
//             >
//                 <span>+</span> New Campaign
//             </button>
//         </div>

//         {/* --- STATS GRID --- */}
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
//           <CompactStatCard 
//             label="Available Credits" 
//             value={`₹${dashboardStats.availableCredits?.toFixed(2)}`} 
//             accentColor="#10B981" 
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z" />}
//           />
//           <CompactStatCard 
//             label="Total Sent" 
//             value={dashboardStats.totalSent.toLocaleString()} 
//             subLabel="All Time"
//             accentColor="#0C4550" 
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />}
//           />
//           <CompactStatCard 
//             label="Delivery Rate" 
//             value={`${successRate}%`} 
//             subLabel={`${dashboardStats.delivered.toLocaleString()} Delivered`}
//             accentColor="#3B82F6" 
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />}
//           />
//           <CompactStatCard 
//             label="Queued" 
//             value={dashboardStats.pending} 
//             accentColor="#F59E0B" 
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />}
//           />
//         </div>

//         {/* --- CHARTS SECTION --- */}
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//             <div className={`lg:col-span-2 rounded-2xl p-6 border shadow-sm flex flex-col h-80 transition-colors duration-300 ${isDarkMode ? 'bg-[#082f36] border-slate-700' : 'bg-white border-slate-100'}`}>
//                 <div className="flex justify-between items-center mb-6">
//                     <div>
//                         <h3 className={`font-bold text-base font-manrope ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>Traffic Volume</h3>
//                         <p className={`text-xs mt-0.5 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Hourly message throughput</p>
//                     </div>
//                 </div>
//                 <div className="flex-1 w-full relative">
//                     <svg className="w-full h-full" preserveAspectRatio="none">
//                         {[0, 0.25, 0.5, 0.75, 1].map((y, i) => (
//                              <line key={i} x1="0" y1={`${y*100}%`} x2="100%" y2={`${y*100}%`} stroke={isDarkMode ? '#1e3a42' : '#f1f5f9'} strokeWidth="1" strokeDasharray="4 4" />
//                         ))}
//                         {chartData.map((val, i) => {
//                              const barWidthPct = 3.5;
//                              const gap = (100 - (chartData.length * barWidthPct)) / (chartData.length + 1);
//                              const x = gap + (i * (barWidthPct + gap)) + (barWidthPct / 2);
//                              const barHeightPct = (val / maxChartVal) * 90;
//                              const yTop = 100 - barHeightPct;
//                              return (
//                                  <g key={i}>
//                                      <line x1={`${x}%`} y1="10%" x2={`${x}%`} y2="100%" stroke={isDarkMode ? '#134e5e' : '#e2e8f0'} strokeWidth="1" strokeLinecap="round" />
//                                      <rect x={`${x - (barWidthPct/2)}%`} y={`${yTop}%`} width={`${barWidthPct}%`} height={`${barHeightPct}%`} rx="4" fill={val > 100 ? '#F46653' : '#0C4550'} className="transition-all duration-500 hover:opacity-80 cursor-pointer" />
//                                  </g>
//                              );
//                         })}
//                     </svg>
//                 </div>
//                 <div className={`flex justify-between mt-3 text-[10px] font-bold font-manrope ${isDarkMode ? 'text-slate-500' : 'text-slate-400'}`}>
//                     <span>00:00</span><span>04:00</span><span>08:00</span><span>12:00</span><span>16:00</span><span>20:00</span>
//                 </div>
//             </div>

//             <div className={`rounded-2xl p-6 border shadow-sm h-80 flex flex-col transition-colors duration-300 ${isDarkMode ? 'bg-[#082f36] border-slate-700' : 'bg-white border-slate-100'}`}>
//                 <h3 className={`font-bold text-base font-manrope mb-2 ${isDarkMode ? 'text-white' : 'text-slate-800'}`}>Delivery Status</h3>
//                 <div className="flex-1 flex flex-row items-center justify-center gap-8 px-2">
//                     <div className="relative w-40 h-40">
//                         <svg viewBox="0 0 80 80" className="w-full h-full transform -rotate-90">
//                            <circle cx="40" cy="40" r={radius} fill="transparent" stroke={isDarkMode ? '#134e5e' : '#f1f5f9'} strokeWidth="6" />
//                            {pieSegments.map((seg) => (
//                               <circle key={seg.label} cx="40" cy="40" r={radius} fill="transparent" stroke={seg.color} strokeWidth="6" strokeDasharray={`${seg.ratio * circumference} ${circumference}`} strokeDashoffset={circumference * -seg.offset} strokeLinecap="round" className="transition-all duration-1000 ease-out" />
//                            ))}
//                         </svg>
//                         <div className="absolute inset-0 flex items-center justify-center flex-col">
//                             <span className={`text-2xl font-extrabold ${isDarkMode ? 'text-white' : 'text-[#0C4550]'}`}>{successRate}%</span>
//                             <span className="text-[9px] text-slate-400 font-bold uppercase">Success</span>
//                         </div>
//                     </div>
//                     <div className="flex flex-col justify-center gap-4">
//                         {pieData.map((d) => (
//                             <div key={d.label} className="flex flex-col items-start">
//                                 <div className="flex items-center gap-1.5 mb-0.5">
//                                     <span className="w-2 h-2 rounded-full" style={{backgroundColor: d.color}}></span>
//                                     <span className={`text-[10px] font-bold uppercase ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>{d.label}</span>
//                                 </div>
//                                 <span className={`text-base font-extrabold ml-3.5 ${isDarkMode ? 'text-white' : 'text-slate-700'}`}>{d.value.toLocaleString()}</span>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             </div>
//         </div>

//         {/* --- RECENT ACTIVITY TABLE --- */}
//         <div className={`rounded-2xl border shadow-sm overflow-hidden transition-colors duration-300 ${isDarkMode ? 'bg-[#082f36] border-slate-700' : 'bg-white border-slate-100'}`}>
//              <div className={`px-6 py-4 border-b flex justify-between items-center ${isDarkMode ? 'bg-[#051F24] border-slate-700' : 'bg-slate-50/50 border-slate-100'}`}>
//                 <h3 className={`font-bold text-sm font-manrope ${isDarkMode ? 'text-white' : 'text-slate-700'}`}>Live Activity Logs</h3>
//                 <span className="text-[10px] font-bold text-[#F46653] bg-[#F46653]/10 px-2 py-1 rounded animate-pulse">LIVE FEED</span>
//              </div>
             
//              <div className="p-0 overflow-x-auto">
//                 <table className="w-full text-left text-xs">
//                     <thead className={`font-medium border-b ${isDarkMode ? 'bg-[#06272e] text-slate-400 border-slate-700' : 'bg-white text-slate-400 border-slate-50'}`}>
//                         <tr>
//                             <th className="px-6 py-4 font-manrope">Status</th>
//                             <th className="px-6 py-4 font-manrope">Type</th>
//                             <th className="px-6 py-4 font-manrope text-right">Count</th>
//                         </tr>
//                     </thead>
//                     <tbody className={`divide-y ${isDarkMode ? 'divide-slate-700' : 'divide-slate-50'}`}>
//                         <tr className="hover:bg-slate-50/5 transition-colors">
//                             <td className="px-6 py-4"><span className="text-emerald-500 bg-emerald-500/10 px-2 py-1 rounded font-bold">Delivered</span></td>
//                             <td className={`px-6 py-4 font-semibold ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>Transactional Route</td>
//                             <td className="px-6 py-4 text-right font-mono text-slate-500">{dashboardStats.delivered.toLocaleString()}</td>
//                         </tr>
//                         <tr className="hover:bg-slate-50/5 transition-colors">
//                             <td className="px-6 py-4"><span className="text-[#F46653] bg-[#F46653]/10 px-2 py-1 rounded font-bold">Failed</span></td>
//                             <td className={`px-6 py-4 font-semibold ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>Operator Filter</td>
//                             <td className="px-6 py-4 text-right font-mono text-slate-500">{dashboardStats.failed}</td>
//                         </tr>
//                         <tr className="hover:bg-slate-50/5 transition-colors">
//                             <td className="px-6 py-4"><span className="text-amber-500 bg-amber-500/10 px-2 py-1 rounded font-bold">Queued</span></td>
//                             <td className={`px-6 py-4 font-semibold ${isDarkMode ? 'text-slate-300' : 'text-slate-700'}`}>System Queue</td>
//                             <td className="px-6 py-4 text-right font-mono text-slate-500">{dashboardStats.pending}</td>
//                         </tr>
//                     </tbody>
//                 </table>
//              </div>
//         </div>
//       </main>

//       {/* SMS Popup */}
//       {isSmsPopupOpen && (
//         <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
//           <div className={`${isDarkMode ? 'bg-[#082f36]' : 'bg-white'} rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-[scale-in_0.2s_ease-out]`}>
//             <div className="px-6 py-4 border-b border-slate-700/50 flex justify-between items-center bg-[#0C4550]">
//                <h2 className="text-sm font-extrabold text-white font-manrope">NEW MESSAGE</h2>
//                <button onClick={() => setIsSmsPopupOpen(false)} className="text-white opacity-70 hover:opacity-100">✕</button>
//             </div>
//             <form onSubmit={handleSmsSubmit} className="p-6 space-y-4">
//               <div>
//                 <label className={`block text-[10px] font-bold uppercase mb-2 ${isDarkMode ? 'text-slate-400' : 'text-slate-500'}`}>Sender ID</label>
//                 <input type="text" className={`w-full px-4 py-3 rounded-xl text-sm font-semibold outline-none border transition-colors focus:border-[#F46653] ${isDarkMode ? 'bg-[#051F24] border-slate-600 text-white' : 'bg-slate-50 border-slate-200 text-[#0C4550]'}`} placeholder="e.g. ALERT" value={smsFormData.senderId} onChange={e => setSmsFormData({...smsFormData, senderId: e.target.value})} />
//               </div>
//               <button type="submit" className="w-full py-3 text-sm font-bold text-white bg-[#F46653] rounded-xl hover:bg-[#d64d3b] transition-all shadow-lg shadow-orange-500/20">Send Campaign</button>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EnterpriseDashboard;





// import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { API_URL } from "../../Constants";

// /* ─────────────────────────────────────────────────────────────────────────────
//    COLOUR TOKENS  (never touch these — keep brand consistent)
// ───────────────────────────────────────────────────────────────────────────── */
// const T = {
//   primary:    '#0C4550',
//   primaryLt:  '#1a6b7a',
//   accent:     '#F46653',
//   accentDk:   '#d64d3b',
//   green:      '#10B981',
//   blue:       '#3B82F6',
//   amber:      '#F59E0B',
//   bgLight:    '#F0EFEB',
//   bgDark:     '#051F24',
//   cardDark:   '#082f36',
//   cardDark2:  '#06272e',
//   borderDark: '#0C4550',
//   slate400:   '#94a3b8',
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    HELPERS
// ───────────────────────────────────────────────────────────────────────────── */
// const fmt   = (n) => (n ?? 0).toLocaleString();
// const fmtPc = (n) => `${(n ?? 0).toFixed(1)}%`;

// /** Collapse FAILED / UNDELIVERED / REJECTED / EXPIRED → single "FAILED" bucket */
// const mergeFailedStatuses = (breakdown = []) => {
//   const map = {};
//   breakdown.forEach(({ status, count }) => {
//     const up = (status ?? '').toUpperCase();
//     const key =
//       up.includes('FAIL') || up.includes('UNDELIVER') || up.includes('REJECT') || up.includes('EXPIRE')
//         ? 'FAILED'
//         : status;
//     map[key] = { status: key, count: (map[key]?.count ?? 0) + count };
//   });
//   return Object.values(map);
// };

// const statusColor = (status = '') => {
//   const s = status.toUpperCase();
//   if (s.includes('DELIVER'))                                          return T.green;
//   if (s.includes('FAIL') || s.includes('REJECT') || s.includes('EXPIRE') || s.includes('UNDELIVER')) return T.accent;
//   if (s.includes('QUEUE') || s.includes('PEND') || s.includes('SENT')) return T.amber;
//   return T.blue;
// };

// const shortDate = (iso = '') => {
//   const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
//   const [, mm, dd] = iso.split('-');
//   return `${months[+mm - 1]} ${+dd}`;
// };

// const getUserIdFromToken = (token) => {
//   try {
//     const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
//     const payload = JSON.parse(decodeURIComponent(atob(base64).split('').map(c =>
//       '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')));
//     return payload.userId || payload.sub || payload.id;
//   } catch { return null; }
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    BAR CHART (SVG — no external lib)
// ───────────────────────────────────────────────────────────────────────────── */
// const BarChart = ({ data = [], dark }) => {
//   const [hovered, setHovered] = useState(null);
//   const svgRef = useRef(null);

//   const PAD = { top: 20, right: 12, bottom: 44, left: 48 };
//   const W = 600, H = 220;
//   const innerW = W - PAD.left - PAD.right;
//   const innerH = H - PAD.top  - PAD.bottom;

//   const maxVal = Math.max(...data.map(d => d.count), 1);
//   const yTicks = 4;
//   const barW    = Math.max(4, (innerW / data.length) * 0.55);
//   const gap     = innerW / data.length;

//   const toY = v => innerH - (v / maxVal) * innerH;

//   // Show every Nth label so they don't crowd
//   const labelStep = data.length <= 10 ? 1 : data.length <= 20 ? 2 : Math.ceil(data.length / 10);

//   const gridColor  = dark ? '#134e5e' : '#e2e8f0';
//   const textColor  = dark ? '#64748b' : '#94a3b8';
//   const barColor   = T.primary;
//   const barHover   = T.primaryLt;
//   const tooltipBg  = dark ? '#082f36' : '#fff';
//   const tooltipTxt = dark ? '#f1f5f9' : '#0f172a';

//   return (
//     <div className="relative w-full h-full">
//       <svg
//         ref={svgRef}
//         viewBox={`0 0 ${W} ${H}`}
//         className="w-full h-full"
//         preserveAspectRatio="xMidYMid meet"
//         onMouseLeave={() => setHovered(null)}
//       >
//         {/* Y-axis gridlines + labels */}
//         {Array.from({ length: yTicks + 1 }, (_, i) => {
//           const val  = Math.round((maxVal * i) / yTicks);
//           const y    = PAD.top + toY(val);
//           const lbl  = val >= 1000 ? `${(val / 1000).toFixed(val % 1000 === 0 ? 0 : 1)}k` : `${val}`;
//           return (
//             <g key={i}>
//               <line x1={PAD.left} y1={y} x2={W - PAD.right} y2={y}
//                     stroke={gridColor} strokeWidth="1" strokeDasharray="3 3" />
//               <text x={PAD.left - 6} y={y + 4} textAnchor="end"
//                     fontSize="10" fill={textColor} fontFamily="Manrope,sans-serif">
//                 {lbl}
//               </text>
//             </g>
//           );
//         })}

//         {/* Bars + x-labels */}
//         {data.map((d, i) => {
//           const bh = Math.max(2, (d.count / maxVal) * innerH);
//           const bx = PAD.left + i * gap + (gap - barW) / 2;
//           const by = PAD.top + innerH - bh;
//           const isHov = hovered === i;

//           return (
//             <g key={i}
//                onMouseEnter={() => setHovered(i)}
//                style={{ cursor: 'pointer' }}>
//               {/* Background rail */}
//               <rect x={bx} y={PAD.top} width={barW} height={innerH}
//                     rx="3" fill={dark ? '#0a3840' : '#f8fafc'} />
//               {/* Actual bar */}
//               <rect x={bx} y={by} width={barW} height={bh}
//                     rx="3" fill={isHov ? barHover : barColor}
//                     style={{ transition: 'fill .15s, y .4s, height .4s' }} />
//               {/* X-axis label */}
//               {i % labelStep === 0 && (
//                 <text
//                   x={bx + barW / 2} y={H - 6}
//                   textAnchor="middle" fontSize="9"
//                   fill={isHov ? (dark ? '#e2e8f0' : T.primary) : textColor}
//                   fontFamily="Manrope,sans-serif"
//                   style={{ userSelect: 'none' }}
//                 >
//                   {shortDate(d.date)}
//                 </text>
//               )}
//             </g>
//           );
//         })}

//         {/* Tooltip */}
//         {hovered !== null && (() => {
//           const d   = data[hovered];
//           const bx  = PAD.left + hovered * gap + (gap - barW) / 2;
//           const bh  = Math.max(2, (d.count / maxVal) * innerH);
//           const by  = PAD.top + innerH - bh;
//           const tw  = 90, th = 36, tx = Math.min(Math.max(bx + barW / 2 - tw / 2, 0), W - tw);
//           const ty  = Math.max(by - th - 6, PAD.top);
//           return (
//             <g>
//               <rect x={tx} y={ty} width={tw} height={th} rx="5"
//                     fill={tooltipBg} stroke={dark ? '#1e3a42' : '#e2e8f0'} strokeWidth="1"
//                     style={{ filter: 'drop-shadow(0 2px 6px rgba(0,0,0,.15))' }} />
//               <text x={tx + tw / 2} y={ty + 13} textAnchor="middle"
//                     fontSize="9" fill={textColor} fontFamily="Manrope,sans-serif">{shortDate(d.date)}</text>
//               <text x={tx + tw / 2} y={ty + 27} textAnchor="middle"
//                     fontSize="12" fontWeight="700" fill={tooltipTxt} fontFamily="Manrope,sans-serif">
//                 {fmt(d.count)}
//               </text>
//             </g>
//           );
//         })()}
//       </svg>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    DONUT CHART (SVG — no external lib)
// ───────────────────────────────────────────────────────────────────────────── */
// const DonutChart = ({ segments, centerLabel, centerSub, dark }) => {
//   const R = 52, SW = 11;
//   const circ = 2 * Math.PI * R;
//   let cum = 0;
//   const total = segments.reduce((s, d) => s + d.value, 0) || 1;
//   const segs = segments.map(d => {
//     const ratio = d.value / total;
//     const s = { ...d, ratio, offset: cum };
//     cum += ratio;
//     return s;
//   });
//   return (
//     <svg viewBox="0 0 120 120" className="w-full h-full">
//       <circle cx="60" cy="60" r={R} fill="none"
//               stroke={dark ? '#134e5e' : '#f1f5f9'} strokeWidth={SW} />
//       {segs.map(seg => (
//         <circle key={seg.label} cx="60" cy="60" r={R} fill="none"
//                 stroke={seg.color} strokeWidth={SW}
//                 strokeDasharray={`${seg.ratio * circ} ${circ}`}
//                 strokeDashoffset={circ * -seg.offset}
//                 strokeLinecap="round"
//                 transform="rotate(-90 60 60)"
//                 style={{ transition: 'stroke-dasharray 1s ease-out' }} />
//       ))}
//       <text x="60" y="56" textAnchor="middle" fontSize="16" fontWeight="800"
//             fill={dark ? '#fff' : T.primary} fontFamily="Manrope,sans-serif">{centerLabel}</text>
//       <text x="60" y="70" textAnchor="middle" fontSize="8" fontWeight="700"
//             fill="#94a3b8" fontFamily="Manrope,sans-serif" letterSpacing="1">{centerSub}</text>
//     </svg>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    STAT CARD
// ───────────────────────────────────────────────────────────────────────────── */
// const StatCard = ({ label, value, sub, iconPath, color, dark }) => (
//   <div className={`relative overflow-hidden rounded-2xl p-5 border transition-all duration-300 group
//     ${dark ? 'bg-[#082f36] border-[#0C4550]' : 'bg-white border-slate-100'} hover:shadow-xl hover:-translate-y-0.5`}>
//     <div className="flex justify-between items-start">
//       <div className="flex-1 min-w-0 pr-3">
//         <p className={`text-[10px] font-bold uppercase tracking-widest mb-2 ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
//           {label}
//         </p>
//         <h3 className={`text-2xl font-extrabold tracking-tight font-manrope truncate ${dark ? 'text-white' : 'text-[#0C4550]'}`}>
//           {value}
//         </h3>
//         {sub && (
//           <p className={`text-[10px] font-semibold mt-1.5 ${dark ? 'text-slate-500' : 'text-slate-400'}`}>{sub}</p>
//         )}
//       </div>
//       <div className="w-11 h-11 rounded-xl flex items-center justify-center text-white shadow-md
//                       group-hover:scale-110 group-hover:shadow-lg transition-all duration-300 flex-shrink-0"
//            style={{ backgroundColor: color }}>
//         <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
//           {iconPath}
//         </svg>
//       </div>
//     </div>
//     {/* <div className="absolute -bottom-6 -right-6 w-24 h-24 rounded-full opacity-[0.04] pointer-events-none"
//          style={{ backgroundColor: color }} /> */}
//   </div>
// );

// /* ─────────────────────────────────────────────────────────────────────────────
//    SECTION CARD wrapper
// ───────────────────────────────────────────────────────────────────────────── */
// const Card = ({ title, subtitle, badge, action, dark, children, className = '' }) => (
//   <div className={`rounded-2xl border shadow-sm overflow-hidden transition-colors duration-300
//     ${dark ? 'bg-[#082f36] border-[#0C4550]/60' : 'bg-white border-slate-100'} ${className}`}>
//     {(title || action) && (
//       <div className={`px-6 py-4 border-b flex justify-between items-center
//         ${dark ? 'border-[#0C4550]/40 bg-[#051F24]/40' : 'border-slate-50 bg-slate-50/60'}`}>
//         <div>
//           <h3 className={`font-bold text-sm font-manrope ${dark ? 'text-white' : 'text-slate-800'}`}>{title}</h3>
//           {subtitle && <p className={`text-[10px] mt-0.5 ${dark ? 'text-slate-500' : 'text-slate-400'}`}>{subtitle}</p>}
//         </div>
//         <div className="flex items-center gap-2">
//           {badge && <span className={`text-[10px] font-bold px-2 py-1 rounded-full ${badge.cls}`}>{badge.text}</span>}
//           {action}
//         </div>
//       </div>
//     )}
//     <div className="p-6">{children}</div>
//   </div>
// );

// /* ─────────────────────────────────────────────────────────────────────────────
//    PROGRESS BAR
// ───────────────────────────────────────────────────────────────────────────── */
// const ProgressBar = ({ value, color, bg }) => (
//   <div className="w-full h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: bg }}>
//     <div className="h-full rounded-full transition-all duration-700" style={{ width: `${Math.min(value, 100)}%`, backgroundColor: color }} />
//   </div>
// );

// /* ─────────────────────────────────────────────────────────────────────────────
//    MAIN COMPONENT
// ───────────────────────────────────────────────────────────────────────────── */
// const EnterpriseDashboard = () => {
//   const [isLoading, setIsLoading]     = useState(true);
//   const [error, setError]             = useState(null);
//   const [activeTab, setActiveTab]     = useState('dashboard');
//   const [dark, setDark]               = useState(false);
//   const [smsOpen, setSmsOpen]         = useState(false);
//   const [smsForm, setSmsForm]         = useState({ senderId: '', templateId: '', template: '' });

//   const [stats, setStats] = useState({
//     availableCredits: 1250.50,
//     totalSubmitted:   0,
//     totalPending:     0,
//     totalDelivered:   0,
//     totalFailed:      0,
//     deliveryRate:     0,
//     totalCampaigns:   0,
//     activeCampaigns:  0,
//     dailyTrend:       [],
//     statusBreakdown:  [],
//     topCampaigns:     [],
//   });

//   /* ── FETCH DASHBOARD ──────────────────────────────────────────────────── */
//   useEffect(() => {
//     const load = async () => {
//       try {
//         setIsLoading(true);
//         setError(null);
//         const token = localStorage.getItem('token');
//         if (!token) throw new Error('Authentication token not found. Please log in.');

//         const userId = localStorage.getItem('userId') || getUserIdFromToken(token);
//         if (!userId) throw new Error('Could not determine User ID from token. Please log in again.');

//         const res = await fetch(`${API_URL}/api/reports/dashboard?userId=${userId}`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//             Accept: 'application/json',
//           },
//         });

//         if (!res.ok) {
//           if (res.status === 401 || res.status === 403) throw new Error('Unauthorized. Please log in again.');
//           throw new Error(`Failed to load dashboard data (HTTP ${res.status})`);
//         }

//         const d = await res.json();
//         setStats(prev => ({
//           ...prev,
//           totalSubmitted:  d.totalSubmitted  ?? 0,
//           totalPending:    d.totalPending    ?? 0,
//           totalDelivered:  d.totalDelivered  ?? 0,
//           totalFailed:     d.totalFailed     ?? 0,
//           deliveryRate:    d.deliveryRate    ?? 0,
//           totalCampaigns:  d.totalCampaigns  ?? 0,
//           activeCampaigns: d.activeCampaigns ?? 0,
//           dailyTrend:      d.dailyTrend      ?? [],
//           statusBreakdown: d.statusBreakdown ?? [],
//           topCampaigns:    d.topCampaigns    ?? [],
//         }));
//       } catch (e) {
//         setError(e.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     load();
//   }, []);

//   /* ── DERIVED DATA ─────────────────────────────────────────────────────── */

//   // Merge FAILED / UNDELIVERED / REJECTED / EXPIRED → one "FAILED" bucket
//   const mergedBreakdown = useMemo(() => mergeFailedStatuses(stats.statusBreakdown), [stats.statusBreakdown]);

//   // Donut segments
//   const donutSegs = useMemo(() => {
//     if (!mergedBreakdown.length) return [{ label: 'No Data', value: 1, color: '#e2e8f0' }];
//     return mergedBreakdown.map(b => ({ label: b.status, value: b.count, color: statusColor(b.status) }));
//   }, [mergedBreakdown]);

//   const totalForPie = donutSegs.reduce((s, d) => s + d.value, 0) || 1;

//   // Top-campaigns delivery percentage
//   const enrichedCampaigns = useMemo(() =>
//     stats.topCampaigns.map(c => ({
//       ...c,
//       deliveryPct: c.submitted > 0 ? ((c.delivered / c.submitted) * 100) : 0,
//     })), [stats.topCampaigns]);

//   /* ── SMS SUBMIT (mock) ────────────────────────────────────────────────── */
//   const handleSmsSubmit = (e) => {
//     e.preventDefault();
//     console.log('Campaign submit:', smsForm);
//     setSmsOpen(false);
//   };

//   /* ── LOADING ──────────────────────────────────────────────────────────── */
//   if (isLoading) {
//     return (
//       <div className={`min-h-screen w-full flex flex-col items-center justify-center ${dark ? 'bg-[#051F24]' : 'bg-[#F0EFEB]'}`}>
//         <div className="relative">
//           <div className="w-14 h-14 rounded-full border-4 border-[#0C4550]/20 animate-spin border-t-[#0C4550]" />
//           <div className="absolute inset-0 flex items-center justify-center">
//             <span className="text-[#0C4550] font-extrabold text-sm font-manrope">EF</span>
//           </div>
//         </div>
//         <p className={`mt-5 font-semibold font-manrope text-sm ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
//           Loading Dashboard…
//         </p>
//       </div>
//     );
//   }

//   /* ── RENDER ───────────────────────────────────────────────────────────── */
//   return (
//     <div className={`w-full min-h-screen font-sans transition-colors duration-500 pb-16 ${dark ? 'bg-[#051F24]' : 'bg-[#F0EFEB]'}`}>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800;900&display=swap');
//         .font-manrope { font-family: 'Manrope', sans-serif; }
//         .scrollbar-thin::-webkit-scrollbar { width: 4px; height: 4px; }
//         .scrollbar-thin::-webkit-scrollbar-track { background: transparent; }
//         .scrollbar-thin::-webkit-scrollbar-thumb { background: #94a3b8; border-radius: 4px; }
//       `}</style>

//       {/* ── NAV ─────────────────────────────────────────────────────────── */}
//       <nav className={`sticky top-0 z-30 backdrop-blur-md border-b px-4 md:px-8 py-3.5 transition-colors duration-300
//         ${dark ? 'bg-[#082f36]/90 border-[#0C4550]/50' : 'bg-white/85 border-slate-200'}`}>
//         <div className="max-w-7xl mx-auto flex justify-between items-center">
//           {/* Logo */}
//           <div className="flex items-center gap-3">
//             <div className="w-9 h-9 bg-gradient-to-br from-[#0C4550] to-[#1a6b7a] rounded-xl
//                             flex items-center justify-center text-white font-extrabold text-sm shadow-md">
//               EF
//             </div>
//             <div className="hidden sm:block">
//               <span className={`font-extrabold text-lg font-manrope leading-none ${dark ? 'text-white' : 'text-[#0C4550]'}`}>
//                 Eurofox
//               </span>
//             </div>
//           </div>

//           {/* Nav tabs */}
//           <div className="flex items-center gap-3">
//             <div className={`flex gap-0.5 p-1 rounded-xl ${dark ? 'bg-[#051F24]' : 'bg-slate-100'}`}>
//               {['Dashboard', 'Reports', 'Settings'].map(tab => (
//                 <button key={tab}
//                   onClick={() => setActiveTab(tab.toLowerCase())}
//                   className={`px-3.5 py-1.5 text-[10px] font-medium rounded-lg transition-all duration-200
//                     ${activeTab === tab.toLowerCase()
//                       ? 'bg-[#0C4550] text-white shadow'
//                       : dark ? 'text-[#0C4550] font-medium bg-white' : 'text-slate-800 hover:text-slate-800'}`}>
//                   {tab}
//                 </button>
//               ))}
//             </div>
//             <div className={`w-px h-5 ${dark ? 'bg-slate-700' : 'bg-slate-300'}`} />
//             {/* Theme toggle */}
//             <button onClick={() => setDark(!dark)}
//               className={`p-2 rounded-xl transition-all ${dark ? 'bg-[#051F24] text-amber-400' : 'bg-slate-100 text-slate-600'}`}>
//               {dark
//                 ? <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/></svg>
//                 : <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/></svg>}
//             </button>
//           </div>
//         </div>
//       </nav>

//       {/* ── MAIN ─────────────────────────────────────────────────────────── */}
//       <main className="max-w-7xl mx-auto px-4 md:px-8 py-8 space-y-7">

//         {/* Error banner */}
//         {error && (
//           <div className="flex items-start gap-3 bg-red-50 border border-red-200 text-red-700 p-4 rounded-xl shadow-sm">
//             <svg className="w-5 h-5 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//               <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
//             </svg>
//             <div className="flex-1">
//               <p className="font-bold text-sm">Failed to load dashboard</p>
//               <p className="text-xs mt-0.5 text-red-600">{error}</p>
//             </div>
//             <button onClick={() => window.location.reload()}
//               className="bg-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-red-600 transition flex-shrink-0">
//               Retry
//             </button>
//           </div>
//         )}

//         {/* ── PAGE HEADER ─────────────────────────────────────────────────── */}
//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-4">
//           <div>
         
//             <h1 className={`text-3xl font-black font-manrope tracking-tight ${dark ? 'text-white' : 'text-[#0C4550]'}`}>
//               Enterprise Dashboard
//             </h1>
//             <p className={`text-sm font-medium mt-1 ${dark ? 'text-slate-400' : 'text-slate-700'}`}>
//               Welcome back, here's what's happening today.
//             </p>
//           </div>
//           <button onClick={() => setSmsOpen(true)}
//             className="flex items-center gap-2 bg-[#0C4550]  text-white text-sm font-bold
//                        py-3 px-6 rounded-xl transition-all duration-200 
//                        hover:-translate-y-0.5 ">
//             <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
//               <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4"/>
//             </svg>
//             New Campaign
//           </button>
//         </div>

//         {/* ── STAT CARDS ──────────────────────────────────────────────────── */}
//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
//           <StatCard dark={dark} label="Credits" color={T.green}
//             value={`₹${(stats.availableCredits ?? 0).toFixed(2)}`}
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

//           <StatCard dark={dark} label="Total Sent" color={T.primary}
//             value={fmt(stats.totalSubmitted)} sub="All time"
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>} />

//           <StatCard dark={dark} label="Delivered" color={T.blue}
//             value={fmt(stats.totalDelivered)} sub={fmtPc(stats.deliveryRate) + ' rate'}
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

//           <StatCard dark={dark} label="Failed" color={T.accent}
//             value={fmt(stats.totalFailed)} sub="Incl. undelivered"
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

//           <StatCard dark={dark} label="Queued" color={T.amber}
//             value={fmt(stats.totalPending)} sub="Awaiting dispatch"
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

//           <StatCard dark={dark} label="Campaigns" color={T.primaryLt}
//             value={fmt(stats.totalCampaigns)} sub={`${fmt(stats.activeCampaigns)} running`}
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>} />
//         </div>

//         {/* ── CHARTS ROW ──────────────────────────────────────────────────── */}
//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

//           {/* Daily Trend Bar Chart */}
//           <Card dark={dark} className="lg:col-span-2"
//             title="Daily Trend"
//             subtitle="Submitted message volume — last 30 days">
//             <div className="h-56">
//               {stats.dailyTrend.length === 0
//                 ? <div className="h-full flex items-center justify-center">
//                     <p className={`text-sm ${dark ? 'text-slate-600' : 'text-slate-400'}`}>No data available yet</p>
//                   </div>
//                 : <BarChart data={stats.dailyTrend} dark={dark} />
//               }
//             </div>
//           </Card>

//           {/* Status Donut */}
//           <Card dark={dark} title="Status Breakdown"
//             subtitle="Merged failure categories">
//             <div className="flex flex-col items-center gap-4">
//               <div className="w-36 h-36">
//                 <DonutChart
//                   segments={donutSegs}
//                   centerLabel={fmtPc(stats.deliveryRate)}
//                   centerSub="SUCCESS"
//                   dark={dark}
//                 />
//               </div>
//               <div className="w-full space-y-2.5">
//                 {donutSegs.map((d, i) => (
//                   <div key={i} className="flex items-center justify-between gap-2">
//                     <div className="flex items-center gap-2 min-w-0">
//                       <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: d.color }} />
//                       <span className={`text-[10px] font-bold uppercase truncate ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
//                         {d.label}
//                       </span>
//                     </div>
//                     <div className="text-right flex-shrink-0">
//                       <span className={`text-xs font-extrabold ${dark ? 'text-white' : 'text-slate-700'}`}>
//                         {fmt(d.value)}
//                       </span>
//                       <span className={`text-[9px] ml-1 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>
//                         {((d.value / totalForPie) * 100).toFixed(1)}%
//                       </span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </Card>
//         </div>

//         {/* ── BOTTOM ROW ──────────────────────────────────────────────────── */}
//         <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">

//           {/* Top Campaigns */}
//           <Card dark={dark} className="lg:col-span-3"
//             title="Top Campaigns"
//             subtitle="Ranked by submitted volume">
//             {enrichedCampaigns.length === 0
//               ? <p className={`text-sm text-center py-6 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>No campaign data available.</p>
//               : <div className="space-y-4 overflow-y-auto max-h-64 scrollbar-thin pr-1">
//                   {enrichedCampaigns.map((c, i) => (
//                     <div key={c.campaignId}
//                          className={`flex flex-col gap-1.5 pb-4 ${i < enrichedCampaigns.length - 1 ? (dark ? 'border-b border-[#0C4550]/30' : 'border-b border-slate-50') : ''}`}>
//                       <div className="flex justify-between items-start gap-2">
//                         <div className="min-w-0 flex items-center gap-2">
//                           <span className={`text-[9px] font-bold w-4 flex-shrink-0 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>
//                             {String(i + 1).padStart(2, '0')}
//                           </span>
//                           <span className={`text-xs font-bold truncate ${dark ? 'text-white' : 'text-slate-800'}`} title={c.campaignName}>
//                             {c.campaignName || c.campaignId}
//                           </span>
//                         </div>
//                         <div className="flex items-center gap-3 flex-shrink-0 text-right">
//                           <div>
//                             <p className={`text-[9px] ${dark ? 'text-slate-500' : 'text-slate-400'}`}>Sent</p>
//                             <p className={`text-xs font-bold ${dark ? 'text-slate-300' : 'text-slate-700'}`}>{fmt(c.submitted)}</p>
//                           </div>
//                           <div>
//                             <p className={`text-[9px] ${dark ? 'text-slate-500' : 'text-slate-400'}`}>Delivered</p>
//                             <p className="text-xs font-bold" style={{ color: T.green }}>{fmt(c.delivered)}</p>
//                           </div>
//                           <div>
//                             <p className={`text-[9px] ${dark ? 'text-slate-500' : 'text-slate-400'}`}>Failed</p>
//                             <p className="text-xs font-bold" style={{ color: T.accent }}>{fmt(c.failed)}</p>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="pl-6">
//                         <ProgressBar
//                           value={c.deliveryPct}
//                           color={T.green}
//                           bg={dark ? '#0a3840' : '#f1f5f9'} />
//                         <p className={`text-[9px] mt-0.5 font-semibold ${dark ? 'text-slate-600' : 'text-slate-400'}`}>
//                           {c.deliveryPct.toFixed(1)}% delivery rate
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//             }
//           </Card>

//           {/* Live Traffic */}
//           <Card dark={dark} className="lg:col-span-2"
//             title="Live Traffic"
//             subtitle="Merged status distribution"
//             badge={{ text: '● LIVE', cls: 'text-[#F46653] bg-[#F46653]/10 animate-pulse' }}>
//             {mergedBreakdown.length === 0
//               ? <p className={`text-sm text-center py-6 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>No traffic data found.</p>
//               : <div className="space-y-3 overflow-y-auto max-h-64 scrollbar-thin pr-1">
//                   {mergedBreakdown.map((item, idx) => {
//                     const total = stats.totalSubmitted || 1;
//                     const pct   = ((item.count / total) * 100);
//                     const color = statusColor(item.status);
//                     return (
//                       <div key={idx}>
//                         <div className="flex justify-between items-center mb-1">
//                           <span className="text-[10px] font-bold px-2 py-0.5 rounded"
//                                 style={{ color, backgroundColor: `${color}20` }}>
//                             {item.status}
//                           </span>
//                           <div className="text-right">
//                             <span className={`text-xs font-extrabold ${dark ? 'text-white' : 'text-slate-700'}`}>
//                               {fmt(item.count)}
//                             </span>
//                             <span className={`text-[10px] ml-1.5 font-semibold ${dark ? 'text-slate-600' : 'text-slate-400'}`}>
//                               {pct.toFixed(1)}%
//                             </span>
//                           </div>
//                         </div>
//                         <ProgressBar value={pct} color={color} bg={dark ? '#0a3840' : '#f1f5f9'} />
//                       </div>
//                     );
//                   })}
//                 </div>
//             }
//           </Card>
//         </div>
//       </main>

//       {/* ── NEW CAMPAIGN MODAL ───────────────────────────────────────────── */}
//       {smsOpen && (
//         <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-50 p-4">
//           <div className={`rounded-2xl shadow-2xl w-full max-w-md overflow-hidden
//             ${dark ? 'bg-[#082f36]' : 'bg-white'}`}>
//             <div className="px-6 py-4 bg-[#0C4550] flex justify-between items-center">
//               <div>
//                 <h2 className="text-sm font-extrabold text-white font-manrope">NEW CAMPAIGN</h2>
//                 <p className="text-[10px] text-white/50 mt-0.5">Fill in the details below</p>
//               </div>
//               <button onClick={() => setSmsOpen(false)}
//                       className="text-white/60 hover:text-white transition text-lg leading-none">✕</button>
//             </div>
//             <form onSubmit={handleSmsSubmit} className="p-6 space-y-4">
//               {['Sender ID', 'Template ID'].map((lbl, i) => {
//                 const field = i === 0 ? 'senderId' : 'templateId';
//                 return (
//                   <div key={lbl}>
//                     <label className={`block text-[10px] font-bold uppercase tracking-wider mb-1.5 ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
//                       {lbl}
//                     </label>
//                     <input type="text"
//                       className={`w-full px-4 py-2.5 rounded-xl text-sm font-semibold outline-none border-2 transition-colors
//                         focus:border-[#0C4550] ${dark ? 'bg-[#051F24] border-[#0C4550]/50 text-white placeholder:text-slate-600' : 'bg-slate-50 border-slate-200 text-[#0C4550] placeholder:text-slate-400'}`}
//                       placeholder={i === 0 ? 'e.g. ALERT' : 'e.g. TMP001'}
//                       value={smsForm[field]}
//                       onChange={e => setSmsForm({ ...smsForm, [field]: e.target.value })} />
//                   </div>
//                 );
//               })}
//               <div>
//                 <label className={`block text-[10px] font-bold uppercase tracking-wider mb-1.5 ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
//                   Message Template
//                 </label>
//                 <textarea rows={3}
//                   className={`w-full px-4 py-2.5 rounded-xl text-sm font-semibold outline-none border-2 transition-colors resize-none
//                     focus:border-[#0C4550] ${dark ? 'bg-[#051F24] border-[#0C4550]/50 text-white placeholder:text-slate-600' : 'bg-slate-50 border-slate-200 text-[#0C4550] placeholder:text-slate-400'}`}
//                   placeholder="Your message content here…"
//                   value={smsForm.template}
//                   onChange={e => setSmsForm({ ...smsForm, template: e.target.value })} />
//               </div>
//               <div className="flex gap-3 pt-1">
//                 <button type="button" onClick={() => setSmsOpen(false)}
//                   className={`flex-1 py-2.5 rounded-xl text-sm font-bold border-2 transition-all
//                     ${dark ? 'border-[#0C4550] text-slate-400 hover:text-white' : 'border-slate-200 text-slate-500 hover:border-slate-300'}`}>
//                   Cancel
//                 </button>
//                 <button type="submit"
//                   className="flex-1 py-2.5 rounded-xl text-sm font-bold text-white bg-[#F46653] hover:bg-[#d64d3b] transition-all shadow-lg shadow-[#F46653]/30">
//                   Send Campaign
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default EnterpriseDashboard;




// import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { API_URL } from "../../Constants";

// /* ─────────────────────────────────────────────────────────────────────────────
//    COLOUR TOKENS  (never touch these — keep brand consistent)
// ───────────────────────────────────────────────────────────────────────────── */
// const T = {
//   primary:     '#0C4550',
//   primaryLt:   '#1a6b7a',
//   accent:      '#F46653',
//   accentDk:    '#d64d3b',
//   green:       '#10B981',
//   blue:        '#3B82F6',
//   amber:       '#F59E0B',
//   bgLight:     '#F0EFEB',
//   bgDark:      '#051F24',
//   cardDark:    '#082f36',
//   cardDark2:   '#06272e',
//   borderDark:  '#0C4550',
//   slate400:    '#94a3b8',
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    HELPERS
// ───────────────────────────────────────────────────────────────────────────── */
// const fmt   = (n) => (n ?? 0).toLocaleString();
// const fmtPc = (n) => `${(n ?? 0).toFixed(1)}%`;

// /** Collapse FAILED / UNDELIVERED / REJECTED / EXPIRED → single "FAILED" bucket */
// const mergeFailedStatuses = (breakdown = []) => {
//   const map = {};
//   breakdown.forEach(({ status, count }) => {
//     const up = (status ?? '').toUpperCase();
//     const key =
//       up.includes('FAIL') || up.includes('UNDELIVER') || up.includes('REJECT') || up.includes('EXPIRE')
//         ? 'FAILED'
//         : status;
//     map[key] = { status: key, count: (map[key]?.count ?? 0) + count };
//   });
//   return Object.values(map);
// };

// const statusColor = (status = '') => {
//   const s = status.toUpperCase();
//   if (s.includes('DELIVER'))                                          return T.green;
//   if (s.includes('FAIL') || s.includes('REJECT') || s.includes('EXPIRE') || s.includes('UNDELIVER')) return T.accent;
//   if (s.includes('QUEUE') || s.includes('PEND') || s.includes('SENT')) return T.amber;
//   return T.blue;
// };

// const shortDate = (iso = '') => {
//   const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
//   const [, mm, dd] = iso.split('-');
//   return `${months[+mm - 1]} ${+dd}`;
// };

// const getUserIdFromToken = (token) => {
//   try {
//     const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
//     const payload = JSON.parse(decodeURIComponent(atob(base64).split('').map(c =>
//       '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')));
//     return payload.userId || payload.sub || payload.id;
//   } catch { return null; }
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    BAR CHART (SVG — no external lib)
// ───────────────────────────────────────────────────────────────────────────── */
// const BarChart = ({ data = [], dark }) => {
//   const [hovered, setHovered] = useState(null);
//   const svgRef = useRef(null);

//   const PAD = { top: 20, right: 12, bottom: 44, left: 48 };
//   const W = 600, H = 220;
//   const innerW = W - PAD.left - PAD.right;
//   const innerH = H - PAD.top  - PAD.bottom;

//   const maxVal = Math.max(...data.map(d => d.count), 1);
//   const yTicks = 4;
//   const barW    = Math.max(4, (innerW / data.length) * 0.55);
//   const gap     = innerW / data.length;

//   const toY = v => innerH - (v / maxVal) * innerH;

//   const labelStep = data.length <= 10 ? 1 : data.length <= 20 ? 2 : Math.ceil(data.length / 10);

//   const gridColor  = dark ? '#134e5e' : '#e2e8f0';
//   const textColor  = dark ? '#64748b' : '#94a3b8';
//   const barColor   = T.primary;
//   const barHover   = T.primaryLt;
//   const tooltipBg  = dark ? '#082f36' : '#fff';
//   const tooltipTxt = dark ? '#f1f5f9' : '#0f172a';

//   return (
//     <div className="relative w-full h-full">
//       <svg
//         ref={svgRef}
//         viewBox={`0 0 ${W} ${H}`}
//         className="w-full h-full"
//         preserveAspectRatio="xMidYMid meet"
//         onMouseLeave={() => setHovered(null)}
//       >
//         {Array.from({ length: yTicks + 1 }, (_, i) => {
//           const val  = Math.round((maxVal * i) / yTicks);
//           const y    = PAD.top + toY(val);
//           const lbl  = val >= 1000 ? `${(val / 1000).toFixed(val % 1000 === 0 ? 0 : 1)}k` : `${val}`;
//           return (
//             <g key={i}>
//               <line x1={PAD.left} y1={y} x2={W - PAD.right} y2={y}
//                     stroke={gridColor} strokeWidth="1" strokeDasharray="3 3" />
//               <text x={PAD.left - 6} y={y + 4} textAnchor="end"
//                     fontSize="10" fill={textColor} fontFamily="Manrope,sans-serif">
//                 {lbl}
//               </text>
//             </g>
//           );
//         })}

//         {data.map((d, i) => {
//           const bh = Math.max(2, (d.count / maxVal) * innerH);
//           const bx = PAD.left + i * gap + (gap - barW) / 2;
//           const by = PAD.top + innerH - bh;
//           const isHov = hovered === i;

//           return (
//             <g key={i}
//                onMouseEnter={() => setHovered(i)}
//                style={{ cursor: 'pointer' }}>
//               <rect x={bx} y={PAD.top} width={barW} height={innerH}
//                     rx="3" fill={dark ? '#0a3840' : '#f8fafc'} />
//               <rect x={bx} y={by} width={barW} height={bh}
//                     rx="3" fill={isHov ? barHover : barColor}
//                     style={{ transition: 'fill .15s, y .4s, height .4s' }} />
//               {i % labelStep === 0 && (
//                 <text
//                   x={bx + barW / 2} y={H - 6}
//                   textAnchor="middle" fontSize="9"
//                   fill={isHov ? (dark ? '#e2e8f0' : T.primary) : textColor}
//                   fontFamily="Manrope,sans-serif"
//                   style={{ userSelect: 'none' }}
//                 >
//                   {shortDate(d.date)}
//                 </text>
//               )}
//             </g>
//           );
//         })}

//         {hovered !== null && (() => {
//           const d   = data[hovered];
//           const bx  = PAD.left + hovered * gap + (gap - barW) / 2;
//           const bh  = Math.max(2, (d.count / maxVal) * innerH);
//           const by  = PAD.top + innerH - bh;
//           const tw  = 90, th = 36, tx = Math.min(Math.max(bx + barW / 2 - tw / 2, 0), W - tw);
//           const ty  = Math.max(by - th - 6, PAD.top);
//           return (
//             <g>
//               <rect x={tx} y={ty} width={tw} height={th} rx="5"
//                     fill={tooltipBg} stroke={dark ? '#1e3a42' : '#e2e8f0'} strokeWidth="1"
//                     style={{ filter: 'drop-shadow(0 2px 6px rgba(0,0,0,.15))' }} />
//               <text x={tx + tw / 2} y={ty + 13} textAnchor="middle"
//                     fontSize="9" fill={textColor} fontFamily="Manrope,sans-serif">{shortDate(d.date)}</text>
//               <text x={tx + tw / 2} y={ty + 27} textAnchor="middle"
//                     fontSize="12" fontWeight="700" fill={tooltipTxt} fontFamily="Manrope,sans-serif">
//                 {fmt(d.count)}
//               </text>
//             </g>
//           );
//         })()}
//       </svg>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    DONUT CHART (SVG — no external lib)
// ───────────────────────────────────────────────────────────────────────────── */
// const DonutChart = ({ segments, centerLabel, centerSub, dark }) => {
//   const R = 52, SW = 11;
//   const circ = 2 * Math.PI * R;
//   let cum = 0;
//   const total = segments.reduce((s, d) => s + d.value, 0) || 1;
//   const segs = segments.map(d => {
//     const ratio = d.value / total;
//     const s = { ...d, ratio, offset: cum };
//     cum += ratio;
//     return s;
//   });
//   return (
//     <svg viewBox="0 0 120 120" className="w-full h-full">
//       <circle cx="60" cy="60" r={R} fill="none"
//               stroke={dark ? '#134e5e' : '#f1f5f9'} strokeWidth={SW} />
//       {segs.map(seg => (
//         <circle key={seg.label} cx="60" cy="60" r={R} fill="none"
//                 stroke={seg.color} strokeWidth={SW}
//                 strokeDasharray={`${seg.ratio * circ} ${circ}`}
//                 strokeDashoffset={circ * -seg.offset}
//                 strokeLinecap="round"
//                 transform="rotate(-90 60 60)"
//                 style={{ transition: 'stroke-dasharray 1s ease-out' }} />
//       ))}
//       <text x="60" y="56" textAnchor="middle" fontSize="16" fontWeight="800"
//             fill={dark ? '#fff' : T.primary} fontFamily="Manrope,sans-serif">{centerLabel}</text>
//       <text x="60" y="70" textAnchor="middle" fontSize="8" fontWeight="700"
//             fill="#94a3b8" fontFamily="Manrope,sans-serif" letterSpacing="1">{centerSub}</text>
//     </svg>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    STAT CARD
// ───────────────────────────────────────────────────────────────────────────── */
// const StatCard = ({ label, value, sub, iconPath, color, dark }) => (
//   <div className={`relative overflow-hidden rounded-2xl p-5 border transition-all duration-300 group
//     ${dark ? 'bg-[#082f36] border-[#0C4550]' : 'bg-white border-slate-100'} hover:shadow-xl hover:-translate-y-0.5`}>
//     <div className="flex justify-between items-start">
//       <div className="flex-1 min-w-0 pr-3">
//         <p className={`text-[10px] font-bold uppercase tracking-widest mb-2 ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
//           {label}
//         </p>
//         <h3 className={`text-2xl font-extrabold tracking-tight font-manrope truncate ${dark ? 'text-white' : 'text-[#0C4550]'}`}>
//           {value}
//         </h3>
//         {sub && (
//           <p className={`text-[10px] font-semibold mt-1.5 ${dark ? 'text-slate-500' : 'text-slate-400'}`}>{sub}</p>
//         )}
//       </div>
//       <div className="w-11 h-11 rounded-xl flex items-center justify-center text-white shadow-md
//                       group-hover:scale-110 group-hover:shadow-lg transition-all duration-300 flex-shrink-0"
//            style={{ backgroundColor: color }}>
//         <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
//           {iconPath}
//         </svg>
//       </div>
//     </div>
//   </div>
// );

// /* ─────────────────────────────────────────────────────────────────────────────
//    SECTION CARD wrapper
// ───────────────────────────────────────────────────────────────────────────── */
// const Card = ({ title, subtitle, badge, action, dark, children, className = '' }) => (
//   <div className={`rounded-2xl border shadow-sm overflow-hidden transition-colors duration-300
//     ${dark ? 'bg-[#082f36] border-[#0C4550]/60' : 'bg-white border-slate-100'} ${className}`}>
//     {(title || action) && (
//       <div className={`px-6 py-4 border-b flex justify-between items-center
//         ${dark ? 'border-[#0C4550]/40 bg-[#051F24]/40' : 'border-slate-50 bg-slate-50/60'}`}>
//         <div>
//           <h3 className={`font-bold text-sm font-manrope ${dark ? 'text-white' : 'text-slate-800'}`}>{title}</h3>
//           {subtitle && <p className={`text-[10px] mt-0.5 ${dark ? 'text-slate-500' : 'text-slate-400'}`}>{subtitle}</p>}
//         </div>
//         <div className="flex items-center gap-2">
//           {badge && <span className={`text-[10px] font-bold px-2 py-1 rounded-full ${badge.cls}`}>{badge.text}</span>}
//           {action}
//         </div>
//       </div>
//     )}
//     <div className="p-6">{children}</div>
//   </div>
// );

// /* ─────────────────────────────────────────────────────────────────────────────
//    PROGRESS BAR
// ───────────────────────────────────────────────────────────────────────────── */
// const ProgressBar = ({ value, color, bg }) => (
//   <div className="w-full h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: bg }}>
//     <div className="h-full rounded-full transition-all duration-700" style={{ width: `${Math.min(value, 100)}%`, backgroundColor: color }} />
//   </div>
// );

// /* ─────────────────────────────────────────────────────────────────────────────
//    MAIN COMPONENT
// ───────────────────────────────────────────────────────────────────────────── */
// const EnterpriseDashboard = () => {
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading]     = useState(true);
//   const [error, setError]             = useState(null);
//   const [activeTab, setActiveTab]     = useState('dashboard');
//   const [dark, setDark]               = useState(false);

//   const [stats, setStats] = useState({
//     availableCredits: 1250.50,
//     totalSubmitted:   0,
//     totalPending:     0,
//     totalDelivered:   0,
//     totalFailed:      0,
//     deliveryRate:     0,
//     totalCampaigns:   0,
//     activeCampaigns:  0,
//     dailyTrend:       [],
//     statusBreakdown:  [],
//     topCampaigns:     [],
//   });

//   /* ── FETCH DASHBOARD ──────────────────────────────────────────────────── */
//   useEffect(() => {
//     const load = async () => {
//       try {
//         setIsLoading(true);
//         setError(null);
//         const token = localStorage.getItem('token');
//         if (!token) throw new Error('Authentication token not found. Please log in.');

//         const userId = localStorage.getItem('userId') || getUserIdFromToken(token);
//         if (!userId) throw new Error('Could not determine User ID from token. Please log in again.');

//         const res = await fetch(`${API_URL}/api/reports/dashboard?userId=${userId}`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//             Accept: 'application/json',
//           },
//         });

//         if (!res.ok) {
//           if (res.status === 401 || res.status === 403) throw new Error('Unauthorized. Please log in again.');
//           throw new Error(`Failed to load dashboard data (HTTP ${res.status})`);
//         }

//         const d = await res.json();
//         setStats(prev => ({
//           ...prev,
//           totalSubmitted:  d.totalSubmitted  ?? 0,
//           totalPending:    d.totalPending    ?? 0,
//           totalDelivered:  d.totalDelivered  ?? 0,
//           totalFailed:     d.totalFailed     ?? 0,
//           deliveryRate:    d.deliveryRate    ?? 0,
//           totalCampaigns:  d.totalCampaigns  ?? 0,
//           activeCampaigns: d.activeCampaigns ?? 0,
//           dailyTrend:      d.dailyTrend      ?? [],
//           statusBreakdown: d.statusBreakdown ?? [],
//           topCampaigns:    d.topCampaigns    ?? [],
//         }));
//       } catch (e) {
//         setError(e.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     load();
//   }, []);

//   /* ── DERIVED DATA ─────────────────────────────────────────────────────── */
//   const mergedBreakdown = useMemo(() => mergeFailedStatuses(stats.statusBreakdown), [stats.statusBreakdown]);

//   const donutSegs = useMemo(() => {
//     if (!mergedBreakdown.length) return [{ label: 'No Data', value: 1, color: '#e2e8f0' }];
//     return mergedBreakdown.map(b => ({ label: b.status, value: b.count, color: statusColor(b.status) }));
//   }, [mergedBreakdown]);

//   const totalForPie = donutSegs.reduce((s, d) => s + d.value, 0) || 1;

//   const enrichedCampaigns = useMemo(() =>
//     stats.topCampaigns.map(c => ({
//       ...c,
//       deliveryPct: c.submitted > 0 ? ((c.delivered / c.submitted) * 100) : 0,
//     })), [stats.topCampaigns]);

//   if (isLoading) {
//     return (
//       <div className={`min-h-screen w-full flex flex-col items-center justify-center ${dark ? 'bg-[#051F24]' : 'bg-[#F0EFEB]'}`}>
//         <div className="relative">
//           <div className="w-14 h-14 rounded-full border-4 border-[#0C4550]/20 animate-spin border-t-[#0C4550]" />
//           <div className="absolute inset-0 flex items-center justify-center">
//             <span className="text-[#0C4550] font-extrabold text-sm font-manrope">EF</span>
//           </div>
//         </div>
//         <p className={`mt-5 font-semibold font-manrope text-sm ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
//           Loading Dashboard…
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div className={`w-full min-h-screen font-sans transition-colors duration-500 pb-16 ${dark ? 'bg-[#051F24]' : 'bg-[#F0EFEB]'}`}>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800;900&display=swap');
//         .font-manrope { font-family: 'Manrope', sans-serif; }
//         .scrollbar-thin::-webkit-scrollbar { width: 4px; height: 4px; }
//         .scrollbar-thin::-webkit-scrollbar-track { background: transparent; }
//         .scrollbar-thin::-webkit-scrollbar-thumb { background: #94a3b8; border-radius: 4px; }
//       `}</style>

//       {/* ── NAV ─────────────────────────────────────────────────────────── */}
//       <nav className={`sticky top-0 z-30 backdrop-blur-md border-b px-4 md:px-8 py-3.5 transition-colors duration-300
//         ${dark ? 'bg-[#082f36]/90 border-[#0C4550]/50' : 'bg-white/85 border-slate-200'}`}>
//         <div className="max-w-7xl mx-auto flex justify-between items-center">
//           <div className="flex items-center gap-3">
//             <div className="w-9 h-9 bg-gradient-to-br from-[#0C4550] to-[#1a6b7a] rounded-xl
//                             flex items-center justify-center text-white font-extrabold text-sm shadow-md">
//               EF
//             </div>
//             <div className="hidden sm:block">
//               <span className={`font-extrabold text-lg font-manrope leading-none ${dark ? 'text-white' : 'text-[#0C4550]'}`}>
//                 Eurofox
//               </span>
//             </div>
//           </div>

//           <div className="flex items-center gap-3">
//             <div className={`flex gap-0.5 p-1 rounded-xl ${dark ? 'bg-[#051F24]' : 'bg-slate-100'}`}>
//               {['Dashboard', 'Reports', 'Settings'].map(tab => (
//                 <button key={tab}
//                   onClick={() => {
//                     const lowTab = tab.toLowerCase();
//                     if (lowTab === 'reports') {
//                       navigate('/reports');
//                     } else if (lowTab === 'settings') {
//                       navigate('/settings');
//                     } else {
//                       setActiveTab(lowTab);
//                     }
//                   }}
//                   className={`px-3.5 py-1.5 text-[10px] font-medium rounded-lg transition-all duration-200
//                     ${activeTab === tab.toLowerCase()
//                       ? 'bg-[#0C4550] text-white shadow'
//                       : dark ? 'text-[#0C4550] font-medium bg-white' : 'text-slate-800 hover:text-slate-800'}`}>
//                   {tab}
//                 </button>
//               ))}
//             </div>
//             <div className={`w-px h-5 ${dark ? 'bg-slate-700' : 'bg-slate-300'}`} />
//             <button onClick={() => setDark(!dark)}
//               className={`p-2 rounded-xl transition-all ${dark ? 'bg-[#051F24] text-amber-400' : 'bg-slate-100 text-slate-600'}`}>
//               {dark
//                 ? <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/></svg>
//                 : <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/></svg>}
//             </button>
//           </div>
//         </div>
//       </nav>

//       {/* ── MAIN ─────────────────────────────────────────────────────────── */}
//       <main className="max-w-7xl mx-auto px-4 md:px-8 py-8 space-y-7">
//         {error && (
//           <div className="flex items-start gap-3 bg-red-50 border border-red-200 text-red-700 p-4 rounded-xl shadow-sm">
//             <svg className="w-5 h-5 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//               <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
//             </svg>
//             <div className="flex-1">
//               <p className="font-bold text-sm">Failed to load dashboard</p>
//               <p className="text-xs mt-0.5 text-red-600">{error}</p>
//             </div>
//             <button onClick={() => window.location.reload()}
//               className="bg-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-red-600 transition flex-shrink-0">
//               Retry
//             </button>
//           </div>
//         )}

//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-4">
//           <div>
//             <h1 className={`text-3xl font-black font-manrope tracking-tight ${dark ? 'text-white' : 'text-[#0C4550]'}`}>
//               Enterprise Dashboard
//             </h1>
//             <p className={`text-sm font-medium mt-1 ${dark ? 'text-slate-400' : 'text-slate-700'}`}>
//               Welcome back, here's what's happening today.
//             </p>
//           </div>
//           <button 
//                 onClick={() => navigate('/sendbulk', { state: { triggerHighlight: true } })}
//                 className="bg-[#0C4550]  text-white text-medium font-medium py-3 px-6 rounded-xl transition-all duration-300 ease-in-out flex items-center gap-2 hover:-translate-y-1 hover:shadow-lg shadow-orange-500/20"
//             >
//                 <span>+</span> New Campaign
//             </button>
//         </div>

//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
//           <StatCard dark={dark} label="Credits" color={T.green}
//             value={`₹${(stats.availableCredits ?? 0).toFixed(2)}`}
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

//           <StatCard dark={dark} label="Total Sent" color={T.primary}
//             value={fmt(stats.totalSubmitted)} sub="All time"
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>} />

//           <StatCard dark={dark} label="Delivered" color={T.blue}
//             value={fmt(stats.totalDelivered)} sub={fmtPc(stats.deliveryRate) + ' rate'}
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

//           <StatCard dark={dark} label="Failed" color={T.accent}
//             value={fmt(stats.totalFailed)} sub="Incl. undelivered"
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

//           <StatCard dark={dark} label="Queued" color={T.amber}
//             value={fmt(stats.totalPending)} sub="Awaiting dispatch"
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

//           <StatCard dark={dark} label="Campaigns" color={T.primaryLt}
//             value={fmt(stats.totalCampaigns)} sub={`${fmt(stats.activeCampaigns)} running`}
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>} />
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//           <Card dark={dark} className="lg:col-span-2"
//             title="Daily Trend"
//             subtitle="Submitted message volume — last 30 days">
//             <div className="h-56">
//               {stats.dailyTrend.length === 0
//                 ? <div className="h-full flex items-center justify-center">
//                     <p className={`text-sm ${dark ? 'text-slate-600' : 'text-slate-400'}`}>No data available yet</p>
//                   </div>
//                 : <BarChart data={stats.dailyTrend} dark={dark} />
//               }
//             </div>
//           </Card>

//           <Card dark={dark} title="Status Breakdown"
//             subtitle="Merged failure categories">
//             <div className="flex flex-col items-center gap-4">
//               <div className="w-36 h-36">
//                 <DonutChart
//                   segments={donutSegs}
//                   centerLabel={fmtPc(stats.deliveryRate)}
//                   centerSub="SUCCESS"
//                   dark={dark}
//                 />
//               </div>
//               <div className="w-full space-y-2.5">
//                 {donutSegs.map((d, i) => (
//                   <div key={i} className="flex items-center justify-between gap-2">
//                     <div className="flex items-center gap-2 min-w-0">
//                       <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: d.color }} />
//                       <span className={`text-[10px] font-bold uppercase truncate ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
//                         {d.label}
//                       </span>
//                     </div>
//                     <div className="text-right flex-shrink-0">
//                       <span className={`text-xs font-extrabold ${dark ? 'text-white' : 'text-slate-700'}`}>
//                         {fmt(d.value)}
//                       </span>
//                       <span className={`text-[9px] ml-1 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>
//                         {((d.value / totalForPie) * 100).toFixed(1)}%
//                       </span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </Card>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
//           <Card dark={dark} className="lg:col-span-3"
//             title="Top Campaigns"
//             subtitle="Ranked by submitted volume">
//             {enrichedCampaigns.length === 0
//               ? <p className={`text-sm text-center py-6 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>No campaign data available.</p>
//               : <div className="space-y-4 overflow-y-auto max-h-64 scrollbar-thin pr-1">
//                   {enrichedCampaigns.map((c, i) => (
//                     <div key={c.campaignId}
//                          className={`flex flex-col gap-1.5 pb-4 ${i < enrichedCampaigns.length - 1 ? (dark ? 'border-b border-[#0C4550]/30' : 'border-b border-slate-50') : ''}`}>
//                       <div className="flex justify-between items-start gap-2">
//                         <div className="min-w-0 flex items-center gap-2">
//                           <span className={`text-[9px] font-bold w-4 flex-shrink-0 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>
//                             {String(i + 1).padStart(2, '0')}
//                           </span>
//                           <span className={`text-xs font-bold truncate ${dark ? 'text-white' : 'text-slate-800'}`} title={c.campaignName}>
//                             {c.campaignName || c.campaignId}
//                           </span>
//                         </div>
//                         <div className="flex items-center gap-3 flex-shrink-0 text-right">
//                           <div>
//                             <p className={`text-[9px] ${dark ? 'text-slate-500' : 'text-slate-400'}`}>Sent</p>
//                             <p className={`text-xs font-bold ${dark ? 'text-slate-300' : 'text-slate-700'}`}>{fmt(c.submitted)}</p>
//                           </div>
//                           <div>
//                             <p className={`text-[9px] ${dark ? 'text-slate-500' : 'text-slate-400'}`}>Delivered</p>
//                             <p className="text-xs font-bold" style={{ color: T.green }}>{fmt(c.delivered)}</p>
//                           </div>
//                           <div>
//                             <p className={`text-[9px] ${dark ? 'text-slate-500' : 'text-slate-400'}`}>Failed</p>
//                             <p className="text-xs font-bold" style={{ color: T.accent }}>{fmt(c.failed)}</p>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="pl-6">
//                         <ProgressBar
//                           value={c.deliveryPct}
//                           color={T.green}
//                           bg={dark ? '#0a3840' : '#f1f5f9'} />
//                         <p className={`text-[9px] mt-0.5 font-semibold ${dark ? 'text-slate-600' : 'text-slate-400'}`}>
//                           {c.deliveryPct.toFixed(1)}% delivery rate
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//             }
//           </Card>

//           <Card dark={dark} className="lg:col-span-2"
//             title="Live Traffic"
//             subtitle="Merged status distribution"
//             badge={{ text: '● LIVE', cls: 'text-[#F46653] bg-[#F46653]/10 animate-pulse' }}>
//             {mergedBreakdown.length === 0
//               ? <p className={`text-sm text-center py-6 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>No traffic data found.</p>
//               : <div className="space-y-3 overflow-y-auto max-h-64 scrollbar-thin pr-1">
//                   {mergedBreakdown.map((item, idx) => {
//                     const total = stats.totalSubmitted || 1;
//                     const pct   = ((item.count / total) * 100);
//                     const color = statusColor(item.status);
//                     return (
//                       <div key={idx}>
//                         <div className="flex justify-between items-center mb-1">
//                           <span className="text-[10px] font-bold px-2 py-0.5 rounded"
//                                 style={{ color, backgroundColor: `${color}20` }}>
//                             {item.status}
//                           </span>
//                           <div className="text-right">
//                             <span className={`text-xs font-extrabold ${dark ? 'text-white' : 'text-slate-700'}`}>
//                               {fmt(item.count)}
//                             </span>
//                             <span className={`text-[10px] ml-1.5 font-semibold ${dark ? 'text-slate-600' : 'text-slate-400'}`}>
//                               {pct.toFixed(1)}%
//                             </span>
//                           </div>
//                         </div>
//                         <ProgressBar value={pct} color={color} bg={dark ? '#0a3840' : '#f1f5f9'} />
//                       </div>
//                     );
//                   })}
//                 </div>
//             }
//           </Card>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default EnterpriseDashboard;




// import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { API_URL } from "../../Constants";

// /* ─────────────────────────────────────────────────────────────────────────────
//    COLOUR TOKENS  (never touch these — keep brand consistent)
// ───────────────────────────────────────────────────────────────────────────── */
// const T = {
//   primary:     '#0C4550',
//   primaryLt:   '#1a6b7a',
//   accent:      '#F46653',
//   accentDk:    '#d64d3b',
//   green:       '#10B981',
//   blue:        '#3B82F6',
//   amber:       '#F59E0B',
//   bgLight:     '#F0EFEB',
//   bgDark:      '#051F24',
//   cardDark:    '#082f36',
//   cardDark2:   '#06272e',
//   borderDark:  '#0C4550',
//   slate400:    '#94a3b8',
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    HELPERS
// ───────────────────────────────────────────────────────────────────────────── */
// const fmt   = (n) => (n ?? 0).toLocaleString();
// const fmtPc = (n) => `${(n ?? 0).toFixed(1)}%`;

// /** Collapse FAILED / UNDELIVERED / REJECTED / EXPIRED → single "FAILED" bucket */
// const mergeFailedStatuses = (breakdown = []) => {
//   const map = {};
//   breakdown.forEach(({ status, count }) => {
//     const up = (status ?? '').toUpperCase();
//     const key =
//       up.includes('FAIL') || up.includes('UNDELIVER') || up.includes('REJECT') || up.includes('EXPIRE')
//         ? 'FAILED'
//         : status;
//     map[key] = { status: key, count: (map[key]?.count ?? 0) + count };
//   });
//   return Object.values(map);
// };

// const statusColor = (status = '') => {
//   const s = status.toUpperCase();
//   if (s.includes('DELIVER'))                                           return T.green;
//   if (s.includes('FAIL') || s.includes('REJECT') || s.includes('EXPIRE') || s.includes('UNDELIVER')) return T.accent;
//   if (s.includes('QUEUE') || s.includes('PEND') || s.includes('SENT')) return T.amber;
//   return T.blue;
// };

// const shortDate = (iso = '') => {
//   const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
//   const [, mm, dd] = iso.split('-');
//   return `${months[+mm - 1]} ${+dd}`;
// };

// const getUserIdFromToken = (token) => {
//   try {
//     const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
//     const payload = JSON.parse(decodeURIComponent(atob(base64).split('').map(c =>
//       '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')));
//     return payload.userId || payload.sub || payload.id;
//   } catch { return null; }
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    BAR CHART (SVG — no external lib)
// ───────────────────────────────────────────────────────────────────────────── */
// const BarChart = ({ data = [], dark }) => {
//   const [hovered, setHovered] = useState(null);
//   const svgRef = useRef(null);

//   const PAD = { top: 20, right: 12, bottom: 44, left: 48 };
//   const W = 600, H = 220;
//   const innerW = W - PAD.left - PAD.right;
//   const innerH = H - PAD.top  - PAD.bottom;

//   const maxVal = Math.max(...data.map(d => d.count), 1);
//   const yTicks = 4;
//   const barW    = Math.max(4, (innerW / data.length) * 0.55);
//   const gap     = innerW / data.length;

//   const toY = v => innerH - (v / maxVal) * innerH;

//   const labelStep = data.length <= 10 ? 1 : data.length <= 20 ? 2 : Math.ceil(data.length / 10);

//   const gridColor  = dark ? '#134e5e' : '#e2e8f0';
//   const textColor  = dark ? '#64748b' : '#94a3b8';
//   const barColor   = T.primary;
//   const barHover   = T.primaryLt;
//   const tooltipBg  = dark ? '#082f36' : '#fff';
//   const tooltipTxt = dark ? '#f1f5f9' : '#0f172a';

//   return (
//     <div className="relative w-full h-full">
//       <svg
//         ref={svgRef}
//         viewBox={`0 0 ${W} ${H}`}
//         className="w-full h-full"
//         preserveAspectRatio="xMidYMid meet"
//         onMouseLeave={() => setHovered(null)}
//       >
//         {Array.from({ length: yTicks + 1 }, (_, i) => {
//           const val  = Math.round((maxVal * i) / yTicks);
//           const y    = PAD.top + toY(val);
//           const lbl  = val >= 1000 ? `${(val / 1000).toFixed(val % 1000 === 0 ? 0 : 1)}k` : `${val}`;
//           return (
//             <g key={i}>
//               <line x1={PAD.left} y1={y} x2={W - PAD.right} y2={y}
//                     stroke={gridColor} strokeWidth="1" strokeDasharray="3 3" />
//               <text x={PAD.left - 6} y={y + 4} textAnchor="end"
//                     fontSize="10" fill={textColor} fontFamily="Manrope,sans-serif">
//                 {lbl}
//               </text>
//             </g>
//           );
//         })}

//         {data.map((d, i) => {
//           const bh = Math.max(2, (d.count / maxVal) * innerH);
//           const bx = PAD.left + i * gap + (gap - barW) / 2;
//           const by = PAD.top + innerH - bh;
//           const isHov = hovered === i;

//           return (
//             <g key={i}
//                onMouseEnter={() => setHovered(i)}
//                style={{ cursor: 'pointer' }}>
//               <rect x={bx} y={PAD.top} width={barW} height={innerH}
//                     rx="3" fill={dark ? '#0a3840' : '#f8fafc'} />
//               <rect x={bx} y={by} width={barW} height={bh}
//                     rx="3" fill={isHov ? barHover : barColor}
//                     style={{ transition: 'fill .15s, y .4s, height .4s' }} />
//               {i % labelStep === 0 && (
//                 <text
//                   x={bx + barW / 2} y={H - 6}
//                   textAnchor="middle" fontSize="9"
//                   fill={isHov ? (dark ? '#e2e8f0' : T.primary) : textColor}
//                   fontFamily="Manrope,sans-serif"
//                   style={{ userSelect: 'none' }}
//                 >
//                   {shortDate(d.date)}
//                 </text>
//               )}
//             </g>
//           );
//         })}

//         {hovered !== null && (() => {
//           const d   = data[hovered];
//           const bx  = PAD.left + hovered * gap + (gap - barW) / 2;
//           const bh  = Math.max(2, (d.count / maxVal) * innerH);
//           const by  = PAD.top + innerH - bh;
//           const tw  = 90, th = 36, tx = Math.min(Math.max(bx + barW / 2 - tw / 2, 0), W - tw);
//           const ty  = Math.max(by - th - 6, PAD.top);
//           return (
//             <g>
//               <rect x={tx} y={ty} width={tw} height={th} rx="5"
//                     fill={tooltipBg} stroke={dark ? '#1e3a42' : '#e2e8f0'} strokeWidth="1"
//                     style={{ filter: 'drop-shadow(0 2px 6px rgba(0,0,0,.15))' }} />
//               <text x={tx + tw / 2} y={ty + 13} textAnchor="middle"
//                     fontSize="9" fill={textColor} fontFamily="Manrope,sans-serif">{shortDate(d.date)}</text>
//               <text x={tx + tw / 2} y={ty + 27} textAnchor="middle"
//                     fontSize="12" fontWeight="700" fill={tooltipTxt} fontFamily="Manrope,sans-serif">
//                 {fmt(d.count)}
//               </text>
//             </g>
//           );
//         })()}
//       </svg>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    DONUT CHART (SVG — no external lib)
// ───────────────────────────────────────────────────────────────────────────── */
// const DonutChart = ({ segments, centerLabel, centerSub, dark }) => {
//   const R = 52, SW = 11;
//   const circ = 2 * Math.PI * R;
//   let cum = 0;
//   const total = segments.reduce((s, d) => s + d.value, 0) || 1;
//   const segs = segments.map(d => {
//     const ratio = d.value / total;
//     const s = { ...d, ratio, offset: cum };
//     cum += ratio;
//     return s;
//   });
//   return (
//     <svg viewBox="0 0 120 120" className="w-full h-full">
//       <circle cx="60" cy="60" r={R} fill="none"
//               stroke={dark ? '#134e5e' : '#f1f5f9'} strokeWidth={SW} />
//       {segs.map(seg => (
//         <circle key={seg.label} cx="60" cy="60" r={R} fill="none"
//                 stroke={seg.color} strokeWidth={SW}
//                 strokeDasharray={`${seg.ratio * circ} ${circ}`}
//                 strokeDashoffset={circ * -seg.offset}
//                 strokeLinecap="round"
//                 transform="rotate(-90 60 60)"
//                 style={{ transition: 'stroke-dasharray 1s ease-out' }} />
//       ))}
//       <text x="60" y="56" textAnchor="middle" fontSize="16" fontWeight="800"
//             fill={dark ? '#fff' : T.primary} fontFamily="Manrope,sans-serif">{centerLabel}</text>
//       <text x="60" y="70" textAnchor="middle" fontSize="8" fontWeight="700"
//             fill="#94a3b8" fontFamily="Manrope,sans-serif" letterSpacing="1">{centerSub}</text>
//     </svg>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────────────
//    STAT CARD
// ───────────────────────────────────────────────────────────────────────────── */
// const StatCard = ({ label, value, sub, iconPath, color, dark }) => (
//   <div className={`relative overflow-hidden rounded-2xl p-5 border transition-all duration-300 group
//     ${dark ? 'bg-[#082f36] border-[#0C4550]' : 'bg-white border-slate-100'} hover:shadow-xl hover:-translate-y-0.5`}>
//     <div className="flex justify-between items-start">
//       <div className="flex-1 min-w-0 pr-3">
//         <p className={`text-[10px] font-bold uppercase tracking-widest mb-2 ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
//           {label}
//         </p>
//         <h3 className={`text-2xl font-extrabold tracking-tight font-manrope truncate ${dark ? 'text-white' : 'text-[#0C4550]'}`}>
//           {value}
//         </h3>
//         {sub && (
//           <p className={`text-[10px] font-semibold mt-1.5 ${dark ? 'text-slate-500' : 'text-slate-400'}`}>{sub}</p>
//         )}
//       </div>
//       <div className="w-11 h-11 rounded-xl flex items-center justify-center text-white shadow-md
//                       group-hover:scale-110 group-hover:shadow-lg transition-all duration-300 flex-shrink-0"
//            style={{ backgroundColor: color }}>
//         <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
//           {iconPath}
//         </svg>
//       </div>
//     </div>
//   </div>
// );

// /* ─────────────────────────────────────────────────────────────────────────────
//    SECTION CARD wrapper
// ───────────────────────────────────────────────────────────────────────────── */
// const Card = ({ title, subtitle, badge, action, dark, children, className = '' }) => (
//   <div className={`rounded-2xl border shadow-sm overflow-hidden transition-colors duration-300
//     ${dark ? 'bg-[#082f36] border-[#0C4550]/60' : 'bg-white border-slate-100'} ${className}`}>
//     {(title || action) && (
//       <div className={`px-6 py-4 border-b flex justify-between items-center
//         ${dark ? 'border-[#0C4550]/40 bg-[#051F24]/40' : 'border-slate-50 bg-slate-50/60'}`}>
//         <div>
//           <h3 className={`font-bold text-sm font-manrope ${dark ? 'text-white' : 'text-slate-800'}`}>{title}</h3>
//           {subtitle && <p className={`text-[10px] mt-0.5 ${dark ? 'text-slate-500' : 'text-slate-400'}`}>{subtitle}</p>}
//         </div>
//         <div className="flex items-center gap-2">
//           {badge && <span className={`text-[10px] font-bold px-2 py-1 rounded-full ${badge.cls}`}>{badge.text}</span>}
//           {action}
//         </div>
//       </div>
//     )}
//     <div className="p-6">{children}</div>
//   </div>
// );

// /* ─────────────────────────────────────────────────────────────────────────────
//    PROGRESS BAR
// ───────────────────────────────────────────────────────────────────────────── */
// const ProgressBar = ({ value, color, bg }) => (
//   <div className="w-full h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: bg }}>
//     <div className="h-full rounded-full transition-all duration-700" style={{ width: `${Math.min(value, 100)}%`, backgroundColor: color }} />
//   </div>
// );

// /* ─────────────────────────────────────────────────────────────────────────────
//    MAIN COMPONENT
// ───────────────────────────────────────────────────────────────────────────── */
// const EnterpriseDashboard = () => {
//   const navigate = useNavigate();
//   const [isLoading, setIsLoading]     = useState(true);
//   const [error, setError]             = useState(null);
//   const [activeTab, setActiveTab]     = useState('dashboard');
//   const [dark, setDark]               = useState(false);

//   const [stats, setStats] = useState({
//     availableCredits: 0,
//     totalSubmitted:   0,
//     totalPending:     0,
//     totalDelivered:   0,
//     totalFailed:      0,
//     deliveryRate:     0,
//     totalCampaigns:   0,
//     activeCampaigns:  0,
//     dailyTrend:       [],
//     statusBreakdown:  [],
//     topCampaigns:     [],
//   });

//   /* ── FETCH DASHBOARD & BALANCE ────────────────────────────────────────── */
//   useEffect(() => {
//     const load = async () => {
//       try {
//         setIsLoading(true);
//         setError(null);
//         const token = localStorage.getItem('token');
//         if (!token) throw new Error('Authentication token not found. Please log in.');

//         const userId = localStorage.getItem('userId') || getUserIdFromToken(token);
//         if (!userId) throw new Error('Could not determine User ID from token. Please log in again.');

//         // 1. Fetch Dashboard Stats
//         const dashRes = await fetch(`${API_URL}/api/reports/dashboard?userId=${userId}`, {
//           headers: {
//             Authorization: `Bearer ${token}`,
//             'Content-Type': 'application/json',
//             Accept: 'application/json',
//           },
//         });

//         // 2. Fetch Wallet Balance
//         const balRes = await fetch(`${API_URL}/api/v1/wallet/balance`, {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               'Content-Type': 'application/json',
//             },
//         });

//         if (!dashRes.ok) {
//           if (dashRes.status === 401 || dashRes.status === 403) throw new Error('Unauthorized. Please log in again.');
//           throw new Error(`Failed to load dashboard data (HTTP ${dashRes.status})`);
//         }

//         const d = await dashRes.json();
//         let currentBalance = 0;

//         if (balRes.ok) {
//             const b = await balRes.json();
//             // Convert paisa to rupees
//             currentBalance = (b.data?.liveBalancePaise ?? 0) / 100;
//         }

//         setStats(prev => ({
//           ...prev,
//           availableCredits: currentBalance,
//           totalSubmitted:  d.totalSubmitted  ?? 0,
//           totalPending:    d.totalPending    ?? 0,
//           totalDelivered:  d.totalDelivered  ?? 0,
//           totalFailed:     d.totalFailed     ?? 0,
//           deliveryRate:    d.deliveryRate    ?? 0,
//           totalCampaigns:  d.totalCampaigns  ?? 0,
//           activeCampaigns: d.activeCampaigns ?? 0,
//           dailyTrend:      d.dailyTrend      ?? [],
//           statusBreakdown: d.statusBreakdown ?? [],
//           topCampaigns:    d.topCampaigns    ?? [],
//         }));
//       } catch (e) {
//         setError(e.message);
//       } finally {
//         setIsLoading(false);
//       }
//     };
//     load();
//   }, []);

//   /* ── DERIVED DATA ─────────────────────────────────────────────────────── */
//   const mergedBreakdown = useMemo(() => mergeFailedStatuses(stats.statusBreakdown), [stats.statusBreakdown]);

//   const donutSegs = useMemo(() => {
//     if (!mergedBreakdown.length) return [{ label: 'No Data', value: 1, color: '#e2e8f0' }];
//     return mergedBreakdown.map(b => ({ label: b.status, value: b.count, color: statusColor(b.status) }));
//   }, [mergedBreakdown]);

//   const totalForPie = donutSegs.reduce((s, d) => s + d.value, 0) || 1;

//   const enrichedCampaigns = useMemo(() =>
//     stats.topCampaigns.map(c => ({
//       ...c,
//       deliveryPct: c.submitted > 0 ? ((c.delivered / c.submitted) * 100) : 0,
//     })), [stats.topCampaigns]);

//   if (isLoading) {
//     return (
//       <div className={`min-h-screen w-full flex flex-col items-center justify-center ${dark ? 'bg-[#051F24]' : 'bg-[#F0EFEB]'}`}>
//         <div className="relative">
//           <div className="w-14 h-14 rounded-full border-4 border-[#0C4550]/20 animate-spin border-t-[#0C4550]" />
//           <div className="absolute inset-0 flex items-center justify-center">
//             <span className="text-[#0C4550] font-extrabold text-sm font-manrope">EF</span>
//           </div>
//         </div>
//         <p className={`mt-5 font-semibold font-manrope text-sm ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
//           Loading Dashboard…
//         </p>
//       </div>
//     );
//   }

//   return (
//     <div className={`w-full min-h-screen font-sans transition-colors duration-500 pb-16 ${dark ? 'bg-[#051F24]' : 'bg-[#F0EFEB]'}`}>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800;900&display=swap');
//         .font-manrope { font-family: 'Manrope', sans-serif; }
//         .scrollbar-thin::-webkit-scrollbar { width: 4px; height: 4px; }
//         .scrollbar-thin::-webkit-scrollbar-track { background: transparent; }
//         .scrollbar-thin::-webkit-scrollbar-thumb { background: #94a3b8; border-radius: 4px; }
//       `}</style>

//       {/* ── NAV ─────────────────────────────────────────────────────────── */}
//       <nav className={`sticky top-0 z-30 backdrop-blur-md border-b px-4 md:px-8 py-3.5 transition-colors duration-300
//         ${dark ? 'bg-[#082f36]/90 border-[#0C4550]/50' : 'bg-white/85 border-slate-200'}`}>
//         <div className="max-w-7xl mx-auto flex justify-between items-center">
//           <div className="flex items-center gap-3">
//             <div className="w-9 h-9 bg-gradient-to-br from-[#0C4550] to-[#1a6b7a] rounded-xl
//                             flex items-center justify-center text-white font-extrabold text-sm shadow-md">
//               EF
//             </div>
//             <div className="hidden sm:block">
//               <span className={`font-extrabold text-lg font-manrope leading-none ${dark ? 'text-white' : 'text-[#0C4550]'}`}>
//                 Eurofox
//               </span>
//             </div>
//           </div>

//           <div className="flex items-center gap-3">
//             <div className={`flex gap-0.5 p-1 rounded-xl ${dark ? 'bg-[#051F24]' : 'bg-slate-100'}`}>
//               {['Dashboard', 'Reports', 'Settings'].map(tab => (
//                 <button key={tab}
//                   onClick={() => {
//                     const lowTab = tab.toLowerCase();
//                     if (lowTab === 'reports') {
//                       navigate('/reports');
//                     } else if (lowTab === 'settings') {
//                       navigate('/settings');
//                     } else {
//                       setActiveTab(lowTab);
//                     }
//                   }}
//                   className={`px-3.5 py-1.5 text-[10px] font-medium rounded-lg transition-all duration-200
//                     ${activeTab === tab.toLowerCase()
//                       ? 'bg-[#0C4550] text-white shadow'
//                       : dark ? 'text-[#0C4550] font-medium bg-white' : 'text-slate-800 hover:text-slate-800'}`}>
//                   {tab}
//                 </button>
//               ))}
//             </div>
//             <div className={`w-px h-5 ${dark ? 'bg-slate-700' : 'bg-slate-300'}`} />
//             <button onClick={() => setDark(!dark)}
//               className={`p-2 rounded-xl transition-all ${dark ? 'bg-[#051F24] text-amber-400' : 'bg-slate-100 text-slate-600'}`}>
//               {dark
//                 ? <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/></svg>
//                 : <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/></svg>}
//             </button>
//           </div>
//         </div>
//       </nav>

//       {/* ── MAIN ─────────────────────────────────────────────────────────── */}
//       <main className="max-w-7xl mx-auto px-4 md:px-8 py-8 space-y-7">
//         {error && (
//           <div className="flex items-start gap-3 bg-red-50 border border-red-200 text-red-700 p-4 rounded-xl shadow-sm">
//             <svg className="w-5 h-5 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
//               <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/>
//             </svg>
//             <div className="flex-1">
//               <p className="font-bold text-sm">Failed to load dashboard</p>
//               <p className="text-xs mt-0.5 text-red-600">{error}</p>
//             </div>
//             <button onClick={() => window.location.reload()}
//               className="bg-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-red-600 transition flex-shrink-0">
//               Retry
//             </button>
//           </div>
//         )}

//         <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-4">
//           <div>
//             <h1 className={`text-3xl font-black font-manrope tracking-tight ${dark ? 'text-white' : 'text-[#0C4550]'}`}>
//               Enterprise Dashboard
//             </h1>
//             <p className={`text-sm font-medium mt-1 ${dark ? 'text-slate-400' : 'text-slate-700'}`}>
//               Welcome back, here's what's happening today.
//             </p>
//           </div>
//           <button 
//                 onClick={() => navigate('/sendbulk', { state: { triggerHighlight: true } })}
//                 className="bg-[#0C4550]  text-white text-medium font-medium py-3 px-6 rounded-xl transition-all duration-300 ease-in-out flex items-center gap-2 hover:-translate-y-1 hover:shadow-lg shadow-orange-500/20"
//             >
//                 <span>+</span> New Campaign
//             </button>
//         </div>

//         <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
//           <StatCard dark={dark} label="Credits" color={T.green}
//             value={`₹${(stats.availableCredits ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

//           <StatCard dark={dark} label="Total Sent" color={T.primary}
//             value={fmt(stats.totalSubmitted)} sub="All time"
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>} />

//           <StatCard dark={dark} label="Delivered" color={T.blue}
//             value={fmt(stats.totalDelivered)} sub={fmtPc(stats.deliveryRate) + ' rate'}
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

//           <StatCard dark={dark} label="Failed" color={T.accent}
//             value={fmt(stats.totalFailed)} sub="Incl. undelivered"
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

//           <StatCard dark={dark} label="Queued" color={T.amber}
//             value={fmt(stats.totalPending)} sub="Awaiting dispatch"
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

//           <StatCard dark={dark} label="Campaigns" color={T.primaryLt}
//             value={fmt(stats.totalCampaigns)} sub={`${fmt(stats.activeCampaigns)} running`}
//             iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>} />
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//           <Card dark={dark} className="lg:col-span-2"
//             title="Daily Trend"
//             subtitle="Submitted message volume — last 30 days">
//             <div className="h-56">
//               {stats.dailyTrend.length === 0
//                 ? <div className="h-full flex items-center justify-center">
//                     <p className={`text-sm ${dark ? 'text-slate-600' : 'text-slate-400'}`}>No data available yet</p>
//                   </div>
//                 : <BarChart data={stats.dailyTrend} dark={dark} />
//               }
//             </div>
//           </Card>

//           <Card dark={dark} title="Status Breakdown"
//             subtitle="Merged failure categories">
//             <div className="flex flex-col items-center gap-4">
//               <div className="w-36 h-36">
//                 <DonutChart
//                   segments={donutSegs}
//                   centerLabel={fmtPc(stats.deliveryRate)}
//                   centerSub="SUCCESS"
//                   dark={dark}
//                 />
//               </div>
//               <div className="w-full space-y-2.5">
//                 {donutSegs.map((d, i) => (
//                   <div key={i} className="flex items-center justify-between gap-2">
//                     <div className="flex items-center gap-2 min-w-0">
//                       <span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: d.color }} />
//                       <span className={`text-[10px] font-bold uppercase truncate ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
//                         {d.label}
//                       </span>
//                     </div>
//                     <div className="text-right flex-shrink-0">
//                       <span className={`text-xs font-extrabold ${dark ? 'text-white' : 'text-slate-700'}`}>
//                         {fmt(d.value)}
//                       </span>
//                       <span className={`text-[9px] ml-1 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>
//                         {((d.value / totalForPie) * 100).toFixed(1)}%
//                       </span>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </Card>
//         </div>

//         <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
//           <Card dark={dark} className="lg:col-span-3"
//             title="Top Campaigns"
//             subtitle="Ranked by submitted volume">
//             {enrichedCampaigns.length === 0
//               ? <p className={`text-sm text-center py-6 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>No campaign data available.</p>
//               : <div className="space-y-4 overflow-y-auto max-h-64 scrollbar-thin pr-1">
//                   {enrichedCampaigns.map((c, i) => (
//                     <div key={c.campaignId}
//                          className={`flex flex-col gap-1.5 pb-4 ${i < enrichedCampaigns.length - 1 ? (dark ? 'border-b border-[#0C4550]/30' : 'border-b border-slate-50') : ''}`}>
//                       <div className="flex justify-between items-start gap-2">
//                         <div className="min-w-0 flex items-center gap-2">
//                           <span className={`text-[9px] font-bold w-4 flex-shrink-0 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>
//                             {String(i + 1).padStart(2, '0')}
//                           </span>
//                           <span className={`text-xs font-bold truncate ${dark ? 'text-white' : 'text-slate-800'}`} title={c.campaignName}>
//                             {c.campaignName || c.campaignId}
//                           </span>
//                         </div>
//                         <div className="flex items-center gap-3 flex-shrink-0 text-right">
//                           <div>
//                             <p className={`text-[9px] ${dark ? 'text-slate-500' : 'text-slate-400'}`}>Sent</p>
//                             <p className={`text-xs font-bold ${dark ? 'text-slate-300' : 'text-slate-700'}`}>{fmt(c.submitted)}</p>
//                           </div>
//                           <div>
//                             <p className={`text-[9px] ${dark ? 'text-slate-500' : 'text-slate-400'}`}>Delivered</p>
//                             <p className="text-xs font-bold" style={{ color: T.green }}>{fmt(c.delivered)}</p>
//                           </div>
//                           <div>
//                             <p className={`text-[9px] ${dark ? 'text-slate-500' : 'text-slate-400'}`}>Failed</p>
//                             <p className="text-xs font-bold" style={{ color: T.accent }}>{fmt(c.failed)}</p>
//                           </div>
//                         </div>
//                       </div>
//                       <div className="pl-6">
//                         <ProgressBar
//                           value={c.deliveryPct}
//                           color={T.green}
//                           bg={dark ? '#0a3840' : '#f1f5f9'} />
//                         <p className={`text-[9px] mt-0.5 font-semibold ${dark ? 'text-slate-600' : 'text-slate-400'}`}>
//                           {c.deliveryPct.toFixed(1)}% delivery rate
//                         </p>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//             }
//           </Card>

//           <Card dark={dark} className="lg:col-span-2"
//             title="Live Traffic"
//             subtitle="Merged status distribution"
//             badge={{ text: '● LIVE', cls: 'text-[#F46653] bg-[#F46653]/10 animate-pulse' }}>
//             {mergedBreakdown.length === 0
//               ? <p className={`text-sm text-center py-6 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>No traffic data found.</p>
//               : <div className="space-y-3 overflow-y-auto max-h-64 scrollbar-thin pr-1">
//                   {mergedBreakdown.map((item, idx) => {
//                     const total = stats.totalSubmitted || 1;
//                     const pct   = ((item.count / total) * 100);
//                     const color = statusColor(item.status);
//                     return (
//                       <div key={idx}>
//                         <div className="flex justify-between items-center mb-1">
//                           <span className="text-[10px] font-bold px-2 py-0.5 rounded"
//                                 style={{ color, backgroundColor: `${color}20` }}>
//                             {item.status}
//                           </span>
//                           <div className="text-right">
//                             <span className={`text-xs font-extrabold ${dark ? 'text-white' : 'text-slate-700'}`}>
//                               {fmt(item.count)}
//                             </span>
//                             <span className={`text-[10px] ml-1.5 font-semibold ${dark ? 'text-slate-600' : 'text-slate-400'}`}>
//                               {pct.toFixed(1)}%
//                             </span>
//                           </div>
//                         </div>
//                         <ProgressBar value={pct} color={color} bg={dark ? '#0a3840' : '#f1f5f9'} />
//                       </div>
//                     );
//                   })}
//                 </div>
//             }
//           </Card>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default EnterpriseDashboard;




import React, { useState, useEffect, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL } from "../../Constants";

/* ─────────────────────────────────────────────────────────────────────────────
   COLOUR TOKENS
───────────────────────────────────────────────────────────────────────────── */
const T = {
  primary:     '#0C4550',
  primaryLt:   '#1a6b7a',
  accent:      '#F46653',
  accentDk:    '#d64d3b',
  green:       '#10B981',
  blue:        '#3B82F6',
  amber:       '#F59E0B',
  bgLight:     '#F0EFEB',
  bgDark:      '#051F24',
  cardDark:    '#082f36',
  cardDark2:   '#06272e',
  borderDark:  '#0C4550',
  slate400:    '#94a3b8',
};

/* ─────────────────────────────────────────────────────────────────────────────
   HELPERS
───────────────────────────────────────────────────────────────────────────── */
const fmt   = (n) => (n ?? 0).toLocaleString();
const fmtPc = (n) => `${(n ?? 0).toFixed(1)}%`;

const mergeFailedStatuses = (breakdown = []) => {
  const map = {};
  breakdown.forEach(({ status, count }) => {
    const up = (status ?? '').toUpperCase();
    const key =
      up.includes('FAIL') || up.includes('UNDELIVER') || up.includes('REJECT') || up.includes('EXPIRE')
        ? 'FAILED'
        : status;
    map[key] = { status: key, count: (map[key]?.count ?? 0) + count };
  });
  return Object.values(map);
};

const statusColor = (status = '') => {
  const s = status.toUpperCase();
  if (s.includes('DELIVER'))                                           return T.green;
  if (s.includes('FAIL') || s.includes('REJECT') || s.includes('EXPIRE') || s.includes('UNDELIVER')) return T.accent;
  if (s.includes('QUEUE') || s.includes('PEND') || s.includes('SENT')) return T.amber;
  return T.blue;
};

const shortDate = (iso = '') => {
  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const [, mm, dd] = iso.split('-');
  return `${months[+mm - 1]} ${+dd}`;
};

const getUserIdFromToken = (token) => {
  try {
    const base64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
    const payload = JSON.parse(decodeURIComponent(atob(base64).split('').map(c =>
      '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join('')));
    return payload.userId || payload.sub || payload.id;
  } catch { return null; }
};

/* ─────────────────────────────────────────────────────────────────────────────
   CHARTS (SVG)
───────────────────────────────────────────────────────────────────────────── */
const BarChart = ({ data = [], dark }) => {
  const [hovered, setHovered] = useState(null);
  const svgRef = useRef(null);
  const PAD = { top: 20, right: 12, bottom: 44, left: 48 };
  const W = 600, H = 220;
  const innerW = W - PAD.left - PAD.right;
  const innerH = H - PAD.top  - PAD.bottom;
  const maxVal = Math.max(...data.map(d => d.count), 1);
  const yTicks = 4;
  const barW    = Math.max(4, (innerW / data.length) * 0.55);
  const gap     = innerW / data.length;
  const toY = v => innerH - (v / maxVal) * innerH;
  const labelStep = data.length <= 10 ? 1 : data.length <= 20 ? 2 : Math.ceil(data.length / 10);
  const gridColor  = dark ? '#134e5e' : '#e2e8f0';
  const textColor  = dark ? '#64748b' : '#94a3b8';
  const barColor   = T.primary;
  const barHover   = T.primaryLt;
  const tooltipBg  = dark ? '#082f36' : '#fff';
  const tooltipTxt = dark ? '#f1f5f9' : '#0f172a';

  return (
    <div className="relative w-full h-full">
      <svg ref={svgRef} viewBox={`0 0 ${W} ${H}`} className="w-full h-full" preserveAspectRatio="xMidYMid meet" onMouseLeave={() => setHovered(null)}>
        {Array.from({ length: yTicks + 1 }, (_, i) => {
          const val  = Math.round((maxVal * i) / yTicks);
          const y    = PAD.top + toY(val);
          const lbl  = val >= 1000 ? `${(val / 1000).toFixed(val % 1000 === 0 ? 0 : 1)}k` : `${val}`;
          return (
            <g key={i}>
              <line x1={PAD.left} y1={y} x2={W - PAD.right} y2={y} stroke={gridColor} strokeWidth="1" strokeDasharray="3 3" />
              <text x={PAD.left - 6} y={y + 4} textAnchor="end" fontSize="10" fill={textColor} fontFamily="Manrope,sans-serif">{lbl}</text>
            </g>
          );
        })}
        {data.map((d, i) => {
          const bh = Math.max(2, (d.count / maxVal) * innerH);
          const bx = PAD.left + i * gap + (gap - barW) / 2;
          const by = PAD.top + innerH - bh;
          const isHov = hovered === i;
          return (
            <g key={i} onMouseEnter={() => setHovered(i)} style={{ cursor: 'pointer' }}>
              <rect x={bx} y={PAD.top} width={barW} height={innerH} rx="3" fill={dark ? '#0a3840' : '#f8fafc'} />
              <rect x={bx} y={by} width={barW} height={bh} rx="3" fill={isHov ? barHover : barColor} style={{ transition: 'fill .15s, y .4s, height .4s' }} />
              {i % labelStep === 0 && (
                <text x={bx + barW / 2} y={H - 6} textAnchor="middle" fontSize="9" fill={isHov ? (dark ? '#e2e8f0' : T.primary) : textColor} fontFamily="Manrope,sans-serif" style={{ userSelect: 'none' }}>
                  {shortDate(d.date)}
                </text>
              )}
            </g>
          );
        })}
        {hovered !== null && (() => {
          const d = data[hovered];
          const bx = PAD.left + hovered * gap + (gap - barW) / 2;
          const bh = Math.max(2, (d.count / maxVal) * innerH);
          const by = PAD.top + innerH - bh;
          const tw = 90, th = 36, tx = Math.min(Math.max(bx + barW / 2 - tw / 2, 0), W - tw);
          const ty = Math.max(by - th - 6, PAD.top);
          return (
            <g>
              <rect x={tx} y={ty} width={tw} height={th} rx="5" fill={tooltipBg} stroke={dark ? '#1e3a42' : '#e2e8f0'} strokeWidth="1" style={{ filter: 'drop-shadow(0 2px 6px rgba(0,0,0,.15))' }} />
              <text x={tx + tw / 2} y={ty + 13} textAnchor="middle" fontSize="9" fill={textColor} fontFamily="Manrope,sans-serif">{shortDate(d.date)}</text>
              <text x={tx + tw / 2} y={ty + 27} textAnchor="middle" fontSize="12" fontWeight="700" fill={tooltipTxt} fontFamily="Manrope,sans-serif">{fmt(d.count)}</text>
            </g>
          );
        })()}
      </svg>
    </div>
  );
};

const DonutChart = ({ segments, centerLabel, centerSub, dark }) => {
  const R = 52, SW = 11;
  const circ = 2 * Math.PI * R;
  let cum = 0;
  const total = segments.reduce((s, d) => s + d.value, 0) || 1;
  const segs = segments.map(d => {
    const ratio = d.value / total;
    const s = { ...d, ratio, offset: cum };
    cum += ratio;
    return s;
  });
  return (
    <svg viewBox="0 0 120 120" className="w-full h-full">
      <circle cx="60" cy="60" r={R} fill="none" stroke={dark ? '#134e5e' : '#f1f5f9'} strokeWidth={SW} />
      {segs.map(seg => (
        <circle key={seg.label} cx="60" cy="60" r={R} fill="none" stroke={seg.color} strokeWidth={SW} strokeDasharray={`${seg.ratio * circ} ${circ}`} strokeDashoffset={circ * -seg.offset} strokeLinecap="round" transform="rotate(-90 60 60)" style={{ transition: 'stroke-dasharray 1s ease-out' }} />
      ))}
      <text x="60" y="56" textAnchor="middle" fontSize="16" fontWeight="800" fill={dark ? '#fff' : T.primary} fontFamily="Manrope,sans-serif">{centerLabel}</text>
      <text x="60" y="70" textAnchor="middle" fontSize="8" fontWeight="700" fill="#94a3b8" fontFamily="Manrope,sans-serif" letterSpacing="1">{centerSub}</text>
    </svg>
  );
};

/* ─────────────────────────────────────────────────────────────────────────────
   STAT CARD (Updated to support Toggle Balance)
───────────────────────────────────────────────────────────────────────────── */
const StatCard = ({ label, value, sub, fullValue, isShowingFull, onToggle, iconPath, color, dark }) => (
  <div className={`relative overflow-hidden rounded-2xl p-5 border transition-all duration-300 group
    ${dark ? 'bg-[#082f36] border-[#0C4550]' : 'bg-white border-slate-100'} hover:shadow-xl hover:-translate-y-0.5`}>
    <div className="flex justify-between items-start">
      <div className="flex-1 min-w-0 pr-3">
        <p className={`text-[10px] font-bold uppercase tracking-widest mb-2 ${dark ? 'text-slate-400' : 'text-slate-500'}`}>
          {label}
        </p>
        <h3 className={`text-2xl font-extrabold tracking-tight font-manrope truncate ${dark ? 'text-white' : 'text-[#0C4550]'}`}>
          {value}
        </h3>
        
        {/* Toggle Balance Logic */}
        {fullValue !== undefined && (
          <div className="mt-1">
            <button 
              onClick={onToggle}
              className={`flex items-center gap-1 text-[9px] font-bold uppercase hover:opacity-80 transition-opacity ${dark ? 'text-slate-500' : 'text-slate-600'}`}
            >
              {isShowingFull ? 'Hide' : 'View'}
              <svg className="w-3 h-3" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
                {isShowingFull 
                  ? <path strokeLinecap="round" strokeLinejoin="round" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.88 9.88l-3.29-3.29m7.532 7.532l3.29 3.29M3 3l18 18" />
                  : <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0zM2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                }
              </svg>
            </button>
            {isShowingFull && (
              <p className={`text-[11px] font-bold font-manrope mt-0.5 ${dark ? 'text-emerald-400' : 'text-emerald-600'}`}>
                {fullValue}
              </p>
            )}
          </div>
        )}

        {sub && (!fullValue || !isShowingFull) && (
          <p className={`text-[10px] font-semibold mt-1.5 ${dark ? 'text-slate-500' : 'text-slate-400'}`}>{sub}</p>
        )}
      </div>
      <div className="w-11 h-11 rounded-xl flex items-center justify-center text-white shadow-md
                      group-hover:scale-110 group-hover:shadow-lg transition-all duration-300 flex-shrink-0"
           style={{ backgroundColor: color }}>
        <svg className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
          {iconPath}
        </svg>
      </div>
    </div>
  </div>
);

const Card = ({ title, subtitle, badge, action, dark, children, className = '' }) => (
  <div className={`rounded-2xl border shadow-sm overflow-hidden transition-colors duration-300
    ${dark ? 'bg-[#082f36] border-[#0C4550]/60' : 'bg-white border-slate-100'} ${className}`}>
    {(title || action) && (
      <div className={`px-6 py-4 border-b flex justify-between items-center
        ${dark ? 'border-[#0C4550]/40 bg-[#051F24]/40' : 'border-slate-50 bg-slate-50/60'}`}>
        <div>
          <h3 className={`font-bold text-sm font-manrope ${dark ? 'text-white' : 'text-slate-800'}`}>{title}</h3>
          {subtitle && <p className={`text-[10px] mt-0.5 ${dark ? 'text-slate-500' : 'text-slate-400'}`}>{subtitle}</p>}
        </div>
        <div className="flex items-center gap-2">
          {badge && <span className={`text-[10px] font-bold px-2 py-1 rounded-full ${badge.cls}`}>{badge.text}</span>}
          {action}
        </div>
      </div>
    )}
    <div className="p-6">{children}</div>
  </div>
);

const ProgressBar = ({ value, color, bg }) => (
  <div className="w-full h-1.5 rounded-full overflow-hidden" style={{ backgroundColor: bg }}>
    <div className="h-full rounded-full transition-all duration-700" style={{ width: `${Math.min(value, 100)}%`, backgroundColor: color }} />
  </div>
);

/* ─────────────────────────────────────────────────────────────────────────────
   MAIN COMPONENT
───────────────────────────────────────────────────────────────────────────── */
const EnterpriseDashboard = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading]     = useState(true);
  const [error, setError]             = useState(null);
  const [activeTab, setActiveTab]     = useState('dashboard');
  const [dark, setDark]               = useState(false);
  const [showFullCredit, setShowFullCredit] = useState(false);

  const [stats, setStats] = useState({
    availableCredits: 0,
    totalSubmitted:   0,
    totalPending:     0,
    totalDelivered:   0,
    totalFailed:      0,
    deliveryRate:     0,
    totalCampaigns:   0,
    activeCampaigns:  0,
    dailyTrend:       [],
    statusBreakdown:  [],
    topCampaigns:     [],
  });

  useEffect(() => {
    const load = async () => {
      try {
        setIsLoading(true);
        setError(null);
        const token = localStorage.getItem('token');
        if (!token) throw new Error('Authentication token not found. Please log in.');

        const userId = localStorage.getItem('userId') || getUserIdFromToken(token);
        if (!userId) throw new Error('Could not determine User ID from token. Please log in again.');

        const [dashRes, balRes] = await Promise.all([
          fetch(`${API_URL}/api/reports/dashboard?userId=${userId}`, {
            headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json', Accept: 'application/json' },
          }),
          fetch(`${API_URL}/api/v1/wallet/balance`, {
            headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
          })
        ]);

        if (!dashRes.ok) throw new Error(`Failed to load dashboard data (HTTP ${dashRes.status})`);

        const d = await dashRes.json();
        let currentBalance = 0;

       if (balRes.ok) { 
            const b = await balRes.json(); 
            // Divide by 100,000 to convert milli-paise to Rupees
            // Make sure the key matches your API (e.g., liveBalancePaise or liveBalanceMilliPaise)
            currentBalance = (b.data?.liveBalancePaise ?? 0) / 100000; 
        }

        setStats(prev => ({
          ...prev,
          availableCredits: currentBalance,
          totalSubmitted:  d.totalSubmitted  ?? 0,
          totalPending:    d.totalPending    ?? 0,
          totalDelivered:  d.totalDelivered  ?? 0,
          totalFailed:     d.totalFailed     ?? 0,
          deliveryRate:    d.deliveryRate    ?? 0,
          totalCampaigns:  d.totalCampaigns  ?? 0,
          activeCampaigns: d.activeCampaigns ?? 0,
          dailyTrend:      d.dailyTrend      ?? [],
          statusBreakdown: d.statusBreakdown ?? [],
          topCampaigns:    d.topCampaigns    ?? [],
        }));
      } catch (e) {
        setError(e.message);
      } finally {
        setIsLoading(false);
      }
    };
    load();
  }, []);

  const mergedBreakdown = useMemo(() => mergeFailedStatuses(stats.statusBreakdown), [stats.statusBreakdown]);
  const donutSegs = useMemo(() => {
    if (!mergedBreakdown.length) return [{ label: 'No Data', value: 1, color: '#e2e8f0' }];
    return mergedBreakdown.map(b => ({ label: b.status, value: b.count, color: statusColor(b.status) }));
  }, [mergedBreakdown]);

  const totalForPie = donutSegs.reduce((s, d) => s + d.value, 0) || 1;
  const enrichedCampaigns = useMemo(() =>
    stats.topCampaigns.map(c => ({
      ...c,
      deliveryPct: c.submitted > 0 ? ((c.delivered / c.submitted) * 100) : 0,
    })), [stats.topCampaigns]);

  if (isLoading) {
    return (
      <div className={`min-h-screen w-full flex flex-col items-center justify-center ${dark ? 'bg-[#051F24]' : 'bg-[#F0EFEB]'}`}>
        <div className="relative">
          <div className="w-14 h-14 rounded-full border-4 border-[#0C4550]/20 animate-spin border-t-[#0C4550]" />
          <div className="absolute inset-0 flex items-center justify-center">
            <span className="text-[#0C4550] font-extrabold text-sm font-manrope">EF</span>
          </div>
        </div>
        <p className={`mt-5 font-semibold font-manrope text-sm ${dark ? 'text-slate-400' : 'text-slate-500'}`}>Loading Dashboard…</p>
      </div>
    );
  }

  return (
    <div className={`w-full min-h-screen font-sans transition-colors duration-500 pb-16 ${dark ? 'bg-[#051F24]' : 'bg-[#F0EFEB]'}`}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Manrope:wght@300;400;500;600;700;800;900&display=swap');
        .font-manrope { font-family: 'Manrope', sans-serif; }
        .scrollbar-thin::-webkit-scrollbar { width: 4px; height: 4px; }
        .scrollbar-thin::-webkit-scrollbar-track { background: transparent; }
        .scrollbar-thin::-webkit-scrollbar-thumb { background: #94a3b8; border-radius: 4px; }
      `}</style>

      <nav className={`sticky top-0 z-30 backdrop-blur-md border-b px-4 md:px-8 py-3.5 transition-colors duration-300
        ${dark ? 'bg-[#082f36]/90 border-[#0C4550]/50' : 'bg-white/85 border-slate-200'}`}>
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 bg-gradient-to-br from-[#0C4550] to-[#1a6b7a] rounded-xl flex items-center justify-center text-white font-extrabold text-sm shadow-md">EF</div>
            <div className="hidden sm:block">
              <span className={`font-extrabold text-lg font-manrope leading-none ${dark ? 'text-white' : 'text-[#0C4550]'}`}>Eurofox</span>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <div className={`flex gap-0.5 p-1 rounded-xl ${dark ? 'bg-[#051F24]' : 'bg-slate-100'}`}>
              {['Dashboard', 'Reports', 'Settings'].map(tab => (
                <button key={tab}
                  onClick={() => {
                    const lowTab = tab.toLowerCase();
                    if (lowTab === 'reports') navigate('/reports');
                    else if (lowTab === 'settings') navigate('/settings');
                    else setActiveTab(lowTab);
                  }}
                  className={`px-3.5 py-1.5 text-[10px] font-medium rounded-lg transition-all duration-200
                    ${activeTab === tab.toLowerCase() ? 'bg-[#0C4550] text-white shadow' : dark ? 'text-[#0C4550] font-medium bg-white' : 'text-slate-800 hover:text-slate-800'}`}>
                  {tab}
                </button>
              ))}
            </div>
            <div className={`w-px h-5 ${dark ? 'bg-slate-700' : 'bg-slate-300'}`} />
            <button onClick={() => setDark(!dark)} className={`p-2 rounded-xl transition-all ${dark ? 'bg-[#051F24] text-amber-400' : 'bg-slate-100 text-slate-600'}`}>
              {dark ? <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"/></svg>
                   : <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"/></svg>}
            </button>
          </div>
        </div>
      </nav>

      <main className="max-w-7xl mx-auto px-4 md:px-8 py-8 space-y-7">
        {error && (
          <div className="flex items-start gap-3 bg-red-50 border border-red-200 text-red-700 p-4 rounded-xl shadow-sm">
            <svg className="w-5 h-5 mt-0.5 flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}><path strokeLinecap="round" strokeLinejoin="round" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"/></svg>
            <div className="flex-1"><p className="font-bold text-sm">Failed to load dashboard</p><p className="text-xs mt-0.5 text-red-600">{error}</p></div>
            <button onClick={() => window.location.reload()} className="bg-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-lg hover:bg-red-600 transition flex-shrink-0">Retry</button>
          </div>
        )}

        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-end gap-4">
          <div>
            <h1 className={`text-3xl font-black font-manrope tracking-tight ${dark ? 'text-white' : 'text-[#0C4550]'}`}>Enterprise Dashboard</h1>
            <p className={`text-sm font-medium mt-1 ${dark ? 'text-slate-400' : 'text-slate-700'}`}>Welcome back, here's what's happening today.</p>
          </div>
          <button onClick={() => navigate('/sendbulk', { state: { triggerHighlight: true } })} className="bg-[#0C4550] text-white text-medium font-medium py-3 px-6 rounded-xl transition-all duration-300 ease-in-out flex items-center gap-2 hover:-translate-y-1 hover:shadow-lg shadow-orange-500/20">
            <span>+</span> New Campaign
          </button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
          {/* Credit StatCard with Toggle Functionality */}
          <StatCard 
            dark={dark} 
            label="Credits" 
            color={T.green}
            value={`₹${(stats.availableCredits ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`}
            fullValue={`₹${(stats.availableCredits ?? 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}
            isShowingFull={showFullCredit}
            onToggle={() => setShowFullCredit(!showFullCredit)}
            iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M9 8h6m-5 0a3 3 0 110 6H9l3 3m-3-6h6m6 1a9 9 0 11-18 0 9 9 0 0118 0z"/>} 
          />

          <StatCard dark={dark} label="Total Sent" color={T.primary}
            value={fmt(stats.totalSubmitted)} sub="All time"
            iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"/>} />

          <StatCard dark={dark} label="Delivered" color={T.blue}
            value={fmt(stats.totalDelivered)} sub={fmtPc(stats.deliveryRate) + ' rate'}
            iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

          <StatCard dark={dark} label="Failed" color={T.accent}
            value={fmt(stats.totalFailed)} sub="Incl. undelivered"
            iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

          <StatCard dark={dark} label="Queued" color={T.amber}
            value={fmt(stats.totalPending)} sub="Awaiting dispatch"
            iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>} />

          <StatCard dark={dark} label="Campaigns" color={T.primaryLt}
            value={fmt(stats.totalCampaigns)} sub={`${fmt(stats.activeCampaigns)} running`}
            iconPath={<path strokeLinecap="round" strokeLinejoin="round" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>} />
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <Card dark={dark} className="lg:col-span-2" title="Daily Trend" subtitle="Submitted message volume — last 30 days">
            <div className="h-56">{stats.dailyTrend.length === 0 ? <div className="h-full flex items-center justify-center"><p className={`text-sm ${dark ? 'text-slate-600' : 'text-slate-400'}`}>No data available yet</p></div> : <BarChart data={stats.dailyTrend} dark={dark} />}</div>
          </Card>
          <Card dark={dark} title="Status Breakdown" subtitle="Merged failure categories">
            <div className="flex flex-col items-center gap-4">
              <div className="w-36 h-36"><DonutChart segments={donutSegs} centerLabel={fmtPc(stats.deliveryRate)} centerSub="SUCCESS" dark={dark} /></div>
              <div className="w-full space-y-2.5">
                {donutSegs.map((d, i) => (
                  <div key={i} className="flex items-center justify-between gap-2">
                    <div className="flex items-center gap-2 min-w-0"><span className="w-2 h-2 rounded-full flex-shrink-0" style={{ backgroundColor: d.color }} /><span className={`text-[10px] font-bold uppercase truncate ${dark ? 'text-slate-400' : 'text-slate-500'}`}>{d.label}</span></div>
                    <div className="text-right flex-shrink-0"><span className={`text-xs font-extrabold ${dark ? 'text-white' : 'text-slate-700'}`}>{fmt(d.value)}</span><span className={`text-[9px] ml-1 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>{((d.value / totalForPie) * 100).toFixed(1)}%</span></div>
                  </div>
                ))}
              </div>
            </div>
          </Card>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-6">
          <Card dark={dark} className="lg:col-span-3" title="Top Campaigns" subtitle="Ranked by submitted volume">
            {enrichedCampaigns.length === 0 ? <p className={`text-sm text-center py-6 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>No campaign data available.</p> :
              <div className="space-y-4 overflow-y-auto max-h-64 scrollbar-thin pr-1">
                {enrichedCampaigns.map((c, i) => (
                  <div key={c.campaignId} className={`flex flex-col gap-1.5 pb-4 ${i < enrichedCampaigns.length - 1 ? (dark ? 'border-b border-[#0C4550]/30' : 'border-b border-slate-50') : ''}`}>
                    <div className="flex justify-between items-start gap-2">
                      <div className="min-w-0 flex items-center gap-2"><span className={`text-[9px] font-bold w-4 flex-shrink-0 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>{String(i + 1).padStart(2, '0')}</span><span className={`text-xs font-bold truncate ${dark ? 'text-white' : 'text-slate-800'}`} title={c.campaignName}>{c.campaignName || c.campaignId}</span></div>
                      <div className="flex items-center gap-3 flex-shrink-0 text-right">
                        <div><p className={`text-[9px] ${dark ? 'text-slate-500' : 'text-slate-400'}`}>Sent</p><p className={`text-xs font-bold ${dark ? 'text-slate-300' : 'text-slate-700'}`}>{fmt(c.submitted)}</p></div>
                        <div><p className={`text-[9px] ${dark ? 'text-slate-500' : 'text-slate-400'}`}>Delivered</p><p className="text-xs font-bold" style={{ color: T.green }}>{fmt(c.delivered)}</p></div>
                        <div><p className={`text-[9px] ${dark ? 'text-slate-500' : 'text-slate-400'}`}>Failed</p><p className="text-xs font-bold" style={{ color: T.accent }}>{fmt(c.failed)}</p></div>
                      </div>
                    </div>
                    <div className="pl-6"><ProgressBar value={c.deliveryPct} color={T.green} bg={dark ? '#0a3840' : '#f1f5f9'} /><p className={`text-[9px] mt-0.5 font-semibold ${dark ? 'text-slate-600' : 'text-slate-400'}`}>{c.deliveryPct.toFixed(1)}% delivery rate</p></div>
                  </div>
                ))}
              </div>
            }
          </Card>
          <Card dark={dark} className="lg:col-span-2" title="Live Traffic" subtitle="Merged status distribution" badge={{ text: '● LIVE', cls: 'text-[#F46653] bg-[#F46653]/10 animate-pulse' }}>
            {mergedBreakdown.length === 0 ? <p className={`text-sm text-center py-6 ${dark ? 'text-slate-600' : 'text-slate-400'}`}>No traffic data found.</p> :
              <div className="space-y-3 overflow-y-auto max-h-64 scrollbar-thin pr-1">
                {mergedBreakdown.map((item, idx) => {
                  const total = stats.totalSubmitted || 1;
                  const pct   = ((item.count / total) * 100);
                  const color = statusColor(item.status);
                  return (
                    <div key={idx}>
                      <div className="flex justify-between items-center mb-1"><span className="text-[10px] font-bold px-2 py-0.5 rounded" style={{ color, backgroundColor: `${color}20` }}>{item.status}</span><div className="text-right"><span className={`text-xs font-extrabold ${dark ? 'text-white' : 'text-slate-700'}`}>{fmt(item.count)}</span><span className={`text-[10px] ml-1.5 font-semibold ${dark ? 'text-slate-600' : 'text-slate-400'}`}>{pct.toFixed(1)}%</span></div></div>
                      <ProgressBar value={pct} color={color} bg={dark ? '#0a3840' : '#f1f5f9'} />
                    </div>
                  );
                })}
              </div>
            }
          </Card>
        </div>
      </main>
    </div>
  );
};

export default EnterpriseDashboard;